// Generated from OpenAPI by scripts/generate-forms.mjs.
import type { FormSchema } from '../forms';
export const operationSchemas: Record<string, FormSchema> = {
  'POST /public/v1/auth/login': {
    type: 'object',
    required: ['email', 'password'],
    properties: {
      email: { type: 'string', format: 'email', maxLength: 320 },
      password: { type: 'string', minLength: 12, maxLength: 128 },
    },
  },
  'POST /public/v1/auth/mfa/email/send': {},
  'POST /public/v1/auth/mfa/verify': {
    type: 'object',
    required: ['method', 'code'],
    properties: {
      method: { type: 'string', enum: ['EMAIL', 'TOTP'] },
      code: { type: 'string', pattern: '^\\d{6}$' },
    },
  },
  'POST /public/v1/auth/refresh': {
    type: 'object',
    required: ['requestFingerprint'],
    properties: { requestFingerprint: { type: 'string', minLength: 16, maxLength: 200 } },
  },
  'POST /public/v1/auth/activation-sessions': {
    type: 'object',
    required: ['token'],
    properties: { token: { type: 'string', minLength: 32, maxLength: 2048 } },
  },
  'POST /public/v1/auth/activation/complete': {
    type: 'object',
    required: ['password'],
    properties: { password: { type: 'string', minLength: 12, maxLength: 128 } },
  },
  'POST /public/v1/auth/password-reset/request': {
    type: 'object',
    required: ['email'],
    properties: { email: { type: 'string', format: 'email', maxLength: 320 } },
  },
  'POST /public/v1/auth/password-reset-sessions': {
    type: 'object',
    required: ['token'],
    properties: { token: { type: 'string', minLength: 32, maxLength: 2048 } },
  },
  'POST /public/v1/auth/password-reset/complete': {
    type: 'object',
    required: ['password'],
    properties: { password: { type: 'string', minLength: 12, maxLength: 128 } },
  },
  'POST /api/v1/auth/logout': { type: 'object', properties: {}, required: [] },
  'POST /api/v1/auth/logout-all': {
    type: 'object',
    required: ['version'],
    properties: { version: { type: 'integer', minimum: 1 } },
  },
  'POST /api/v1/auth/change-password': {
    type: 'object',
    required: ['currentPassword', 'newPassword'],
    properties: {
      currentPassword: { type: 'string', minLength: 12, maxLength: 128 },
      newPassword: { type: 'string', minLength: 12, maxLength: 128 },
    },
  },
  'POST /api/v1/auth/mfa/email/enrollment': {},
  'POST /api/v1/auth/mfa/email/enrollment/verify': {
    type: 'object',
    required: ['code'],
    properties: { code: { type: 'string', pattern: '^\\d{6}$' } },
  },
  'POST /api/v1/auth/mfa/totp/enrollment': {},
  'POST /api/v1/auth/mfa/totp/enrollment/verify': {
    type: 'object',
    required: ['code'],
    properties: { code: { type: 'string', pattern: '^\\d{6}$' } },
  },
  'POST /api/v1/notifications/{notificationId}/read': {},
  'POST /api/v1/notifications/read-all': {},
  'PUT /api/v1/notification-preferences/{category}': {
    type: 'object',
    required: ['emailEnabled', 'inAppEnabled'],
    properties: { emailEnabled: { type: 'boolean' }, inAppEnabled: { type: 'boolean' } },
  },
  'PATCH /api/v1/me/appearance': {
    type: 'object',
    required: ['color'],
    additionalProperties: false,
    properties: { color: { type: ['string', 'null'], pattern: '^#[0-9a-fA-F]{6}$' } },
  },
  'POST /api/v1/accounts': {
    type: 'object',
    required: ['employeeId', 'email', 'permissionGroupIds', 'organizationId'],
    properties: {
      employeeId: { type: ['string', 'null'], format: 'uuid' },
      email: { type: 'string', format: 'email', maxLength: 320 },
      permissionGroupIds: { type: 'array', items: { type: 'string', format: 'uuid' } },
      organizationId: { type: 'string', format: 'uuid' },
      workAreas: {
        type: 'array',
        minItems: 1,
        maxItems: 2,
        items: { type: 'string', enum: ['HR', 'ADMINISTRATIVE'] },
        properties: {},
        required: [],
      },
    },
  },
  'PATCH /api/v1/accounts/{accountId}/work-areas': {
    type: 'object',
    required: ['workAreas', 'version'],
    additionalProperties: false,
    properties: {
      workAreas: {
        type: 'array',
        minItems: 1,
        maxItems: 2,
        items: { type: 'string', enum: ['HR', 'ADMINISTRATIVE'] },
      },
      version: { type: 'integer', minimum: 1 },
    },
  },
  'POST /api/v1/accounts/{accountId}/activation-links': {
    type: 'object',
    required: ['version'],
    properties: { version: { type: 'integer', minimum: 1 } },
  },
  'POST /api/v1/accounts/{accountId}/password-reset-links': {
    type: 'object',
    required: ['version'],
    properties: { version: { type: 'integer', minimum: 1 } },
  },
  'POST /api/v1/accounts/{accountId}/block': {
    type: 'object',
    required: ['version', 'reason'],
    properties: {
      version: { type: 'integer', minimum: 1 },
      reason: { type: 'string', minLength: 1, maxLength: 2000 },
    },
  },
  'POST /api/v1/accounts/{accountId}/unblock': {
    type: 'object',
    required: ['version', 'reason'],
    properties: {
      version: { type: 'integer', minimum: 1 },
      reason: { type: 'string', minLength: 1, maxLength: 2000 },
    },
  },
  'POST /api/v1/accounts/{accountId}/disable': {
    type: 'object',
    required: ['version', 'reason'],
    properties: {
      version: { type: 'integer', minimum: 1 },
      reason: { type: 'string', minLength: 1, maxLength: 2000 },
    },
  },
  'POST /api/v1/accounts/{accountId}/reactivate': {
    type: 'object',
    required: ['version', 'reason'],
    properties: {
      version: { type: 'integer', minimum: 1 },
      reason: { type: 'string', minLength: 1, maxLength: 2000 },
    },
  },
  'DELETE /api/v1/accounts/{accountId}/sessions/{sessionId}': {},
  'POST /api/v1/permission-groups': {
    type: 'object',
    required: ['name', 'grants'],
    properties: {
      name: { type: 'string', minLength: 1, maxLength: 120 },
      grants: {
        type: 'array',
        items: {
          type: 'object',
          required: ['permission', 'scope', 'scopeEntityId'],
          properties: {
            permission: { type: 'string' },
            scope: {
              type: 'string',
              enum: [
                'WORKSPACE',
                'ORGANIZATION',
                'DEPARTMENT',
                'TEAM',
                'SELF',
                'DIRECT_REPORTS',
                'ASSIGNED_ENTITIES',
              ],
            },
            scopeEntityId: { type: ['string', 'null'], format: 'uuid' },
          },
        },
      },
    },
  },
  'PATCH /api/v1/permission-groups/{groupId}': {
    type: 'object',
    required: ['version'],
    properties: {
      version: { type: 'integer', minimum: 1 },
      name: { type: 'string', minLength: 1, maxLength: 120 },
      grants: {
        type: 'array',
        items: {
          type: 'object',
          required: ['permission', 'scope', 'scopeEntityId'],
          properties: {
            permission: { type: 'string' },
            scope: {
              type: 'string',
              enum: [
                'WORKSPACE',
                'ORGANIZATION',
                'DEPARTMENT',
                'TEAM',
                'SELF',
                'DIRECT_REPORTS',
                'ASSIGNED_ENTITIES',
              ],
            },
            scopeEntityId: { type: ['string', 'null'], format: 'uuid' },
          },
        },
      },
    },
  },
  'PUT /api/v1/accounts/{accountId}/permission-assignments/{assignmentId}': {
    type: 'object',
    required: ['permissionGroupId', 'organizationId'],
    properties: {
      permissionGroupId: { type: 'string', format: 'uuid' },
      organizationId: { type: ['string', 'null'], format: 'uuid' },
    },
  },
  'DELETE /api/v1/accounts/{accountId}/permission-assignments/{assignmentId}': {},
  'POST /api/v1/accounts/{accountId}/permission-overrides': {
    type: 'object',
    required: ['permission', 'effect', 'entityType', 'entityId', 'reason'],
    properties: {
      permission: { type: 'string' },
      effect: { type: 'string', enum: ['ALLOW', 'DENY'] },
      entityType: { type: 'string' },
      entityId: { type: 'string', format: 'uuid' },
      reason: { type: 'string', maxLength: 2000 },
    },
  },
  'DELETE /api/v1/accounts/{accountId}/permission-overrides/{overrideId}': {},
  'POST /api/v1/service-accounts': {
    type: 'object',
    required: ['name', 'expiresAt', 'grants'],
    properties: {
      name: { type: 'string', minLength: 1, maxLength: 120 },
      expiresAt: { type: 'string', format: 'date-time' },
      grants: {
        type: 'array',
        items: {
          type: 'object',
          required: ['permission', 'scope', 'scopeEntityId'],
          properties: {
            permission: { type: 'string' },
            scope: {
              type: 'string',
              enum: [
                'WORKSPACE',
                'ORGANIZATION',
                'DEPARTMENT',
                'TEAM',
                'SELF',
                'DIRECT_REPORTS',
                'ASSIGNED_ENTITIES',
              ],
            },
            scopeEntityId: { type: ['string', 'null'], format: 'uuid' },
          },
        },
      },
    },
  },
  'POST /api/v1/service-accounts/{id}/rotate': {
    type: 'object',
    required: ['version', 'expiresAt'],
    properties: {
      version: { type: 'integer', minimum: 1 },
      expiresAt: { type: 'string', format: 'date-time' },
    },
  },
  'POST /api/v1/service-accounts/{id}/revoke': {
    type: 'object',
    required: ['version'],
    properties: { version: { type: 'integer', minimum: 1 } },
  },
  'PATCH /api/v1/workspace': {
    type: 'object',
    required: ['version'],
    properties: {
      version: { type: 'integer', minimum: 1 },
      name: { type: 'string' },
      timezone: { type: 'string' },
      defaultLocale: { type: 'string' },
    },
  },
  'POST /api/v1/organizations': {
    type: 'object',
    required: ['name'],
    properties: { name: { type: 'string', minLength: 1, maxLength: 200 } },
  },
  'PATCH /api/v1/organizations/{organizationId}': {
    type: 'object',
    required: ['version'],
    properties: {
      version: { type: 'integer', minimum: 1 },
      name: { type: 'string', minLength: 1, maxLength: 200 },
    },
  },
  'POST /api/v1/departments': {
    type: 'object',
    required: ['organizationId', 'name'],
    properties: {
      organizationId: { type: 'string', format: 'uuid' },
      name: { type: 'string' },
      code: { type: 'string' },
      ownerEmployeeId: { type: ['string', 'null'], format: 'uuid' },
      description: { type: ['string', 'null'], maxLength: 5000 },
    },
  },
  'PATCH /api/v1/departments/{departmentId}': {
    type: 'object',
    required: ['version'],
    properties: {
      version: { type: 'integer', minimum: 1 },
      name: { type: 'string' },
      code: { type: 'string' },
      ownerEmployeeId: { type: ['string', 'null'], format: 'uuid' },
      description: { type: ['string', 'null'], maxLength: 5000 },
    },
  },
  'POST /api/v1/departments/{departmentId}/archive': {
    type: 'object',
    required: ['version'],
    properties: {
      version: { type: 'integer', minimum: 1 },
      reason: { type: 'string', minLength: 1, maxLength: 2000 },
    },
  },
  'POST /api/v1/teams': {
    type: 'object',
    required: ['organizationId', 'name'],
    properties: {
      departmentId: { type: ['string', 'null'], format: 'uuid' },
      name: { type: 'string' },
      code: { type: 'string' },
      ownerEmployeeId: { type: ['string', 'null'], format: 'uuid' },
      managerEmployeeId: { type: ['string', 'null'], format: 'uuid' },
      organizationId: { type: 'string', format: 'uuid' },
      description: { type: ['string', 'null'], maxLength: 5000 },
      startDate: { type: ['string', 'null'], format: 'date' },
      endDate: { type: ['string', 'null'], format: 'date' },
      status: { type: 'string', enum: ['ACTIVE', 'COMPLETED', 'ARCHIVED'] },
    },
  },
  'PATCH /api/v1/teams/{teamId}': {
    type: 'object',
    required: ['version'],
    properties: {
      version: { type: 'integer', minimum: 1 },
      name: { type: 'string' },
      code: { type: 'string' },
      ownerEmployeeId: { type: ['string', 'null'], format: 'uuid' },
      managerEmployeeId: { type: ['string', 'null'], format: 'uuid' },
      departmentId: { type: ['string', 'null'], format: 'uuid' },
      description: { type: ['string', 'null'], maxLength: 5000 },
      startDate: { type: ['string', 'null'], format: 'date' },
      endDate: { type: ['string', 'null'], format: 'date' },
      status: { type: 'string', enum: ['ACTIVE', 'COMPLETED', 'ARCHIVED'] },
    },
  },
  'POST /api/v1/teams/{teamId}/archive': {
    type: 'object',
    required: ['version'],
    properties: {
      version: { type: 'integer', minimum: 1 },
      reason: { type: 'string', minLength: 1, maxLength: 2000 },
    },
  },
  'POST /api/v1/job-functions': {
    type: 'object',
    required: ['name', 'code', 'organizationId', 'ownerEmployeeId'],
    properties: {
      name: { type: 'string', minLength: 1, maxLength: 200 },
      code: { type: 'string', minLength: 1, maxLength: 100 },
      organizationId: { type: 'string', format: 'uuid' },
      ownerEmployeeId: { type: ['string', 'null'], format: 'uuid' },
    },
  },
  'PATCH /api/v1/job-functions/{id}': {
    type: 'object',
    required: ['version'],
    properties: {
      version: { type: 'integer', minimum: 1 },
      name: { type: 'string', minLength: 1, maxLength: 200 },
      code: { type: 'string', minLength: 1, maxLength: 100 },
      ownerEmployeeId: { type: ['string', 'null'], format: 'uuid' },
    },
  },
  'POST /api/v1/specialisations': {
    type: 'object',
    required: ['name', 'code', 'organizationId', 'ownerEmployeeId', 'jobFunctionId'],
    properties: {
      name: { type: 'string', minLength: 1, maxLength: 200 },
      code: { type: 'string', minLength: 1, maxLength: 100 },
      organizationId: { type: 'string', format: 'uuid' },
      ownerEmployeeId: { type: ['string', 'null'], format: 'uuid' },
      jobFunctionId: { type: 'string', format: 'uuid' },
    },
  },
  'PATCH /api/v1/specialisations/{id}': {
    type: 'object',
    required: ['version'],
    properties: {
      version: { type: 'integer', minimum: 1 },
      name: { type: 'string', minLength: 1, maxLength: 200 },
      code: { type: 'string', minLength: 1, maxLength: 100 },
      ownerEmployeeId: { type: ['string', 'null'], format: 'uuid' },
      jobFunctionId: { type: 'string', format: 'uuid' },
    },
  },
  'POST /api/v1/seniorities': {
    type: 'object',
    required: ['name', 'code', 'organizationId', 'ownerEmployeeId', 'rank'],
    properties: {
      name: { type: 'string', minLength: 1, maxLength: 200 },
      code: { type: 'string', minLength: 1, maxLength: 100 },
      organizationId: { type: 'string', format: 'uuid' },
      ownerEmployeeId: { type: ['string', 'null'], format: 'uuid' },
      rank: { type: 'integer' },
    },
  },
  'PATCH /api/v1/seniorities/{id}': {
    type: 'object',
    required: ['version'],
    properties: {
      version: { type: 'integer', minimum: 1 },
      name: { type: 'string', minLength: 1, maxLength: 200 },
      code: { type: 'string', minLength: 1, maxLength: 100 },
      ownerEmployeeId: { type: ['string', 'null'], format: 'uuid' },
      rank: { type: 'integer' },
    },
  },
  'POST /api/v1/locations': {
    type: 'object',
    required: ['name', 'code', 'organizationId', 'ownerEmployeeId', 'countryCode', 'timezone'],
    properties: {
      name: { type: 'string', minLength: 1, maxLength: 200 },
      code: { type: 'string', minLength: 1, maxLength: 100 },
      organizationId: { type: 'string', format: 'uuid' },
      ownerEmployeeId: { type: ['string', 'null'], format: 'uuid' },
      countryCode: { type: 'string', pattern: '^[A-Z]{2}$' },
      timezone: { type: 'string', minLength: 1 },
    },
  },
  'PATCH /api/v1/locations/{id}': {
    type: 'object',
    required: ['version'],
    properties: {
      version: { type: 'integer', minimum: 1 },
      name: { type: 'string', minLength: 1, maxLength: 200 },
      code: { type: 'string', minLength: 1, maxLength: 100 },
      ownerEmployeeId: { type: ['string', 'null'], format: 'uuid' },
      countryCode: { type: 'string', pattern: '^[A-Z]{2}$' },
      timezone: { type: 'string' },
    },
  },
  'POST /api/v1/employees': {
    type: 'object',
    required: [
      'workName',
      'workEmail',
      'organizationId',
      'departmentId',
      'seniorityId',
      'locationId',
      'startDate',
    ],
    properties: {
      employeeNumber: { type: 'string' },
      workName: { type: 'string' },
      workEmail: { type: 'string', format: 'email', maxLength: 320 },
      jobTitle: { type: 'string' },
      organizationId: { type: 'string', format: 'uuid' },
      departmentId: { type: 'string', format: 'uuid' },
      primaryTeamId: { type: ['string', 'null'], format: 'uuid' },
      additionalTeamIds: { type: 'array', items: { type: 'string', format: 'uuid' } },
      jobFunctionId: { type: ['string', 'null'], format: 'uuid' },
      specialisationId: { type: ['string', 'null'], format: 'uuid' },
      seniorityId: { type: 'string', format: 'uuid' },
      locationId: { type: 'string', format: 'uuid' },
      employmentType: { type: 'string', enum: ['FULL_TIME', 'PART_TIME', 'CONTRACTOR'] },
      externalEmployee: { type: 'boolean' },
      lineManagerId: { type: ['string', 'null'], format: 'uuid' },
      functionalManagerId: { type: ['string', 'null'], format: 'uuid' },
      buddyId: { type: ['string', 'null'], format: 'uuid' },
      startDate: { type: 'string', format: 'date', pattern: '^\\d{4}-\\d{2}-\\d{2}$' },
      contractEndDate: { type: ['string', 'null'], format: 'date' },
      positionId: { type: ['string', 'null'], format: 'uuid' },
      workTelegram: { type: ['string', 'null'], maxLength: 200 },
      personalTelegram: { type: ['string', 'null'], maxLength: 200 },
      workFormat: { type: 'string', enum: ['OFFICE', 'REMOTE', 'HYBRID'] },
      status: {
        type: 'string',
        enum: ['JOINING', 'PROBATION', 'ACTIVE', 'ON_LEAVE', 'OFFBOARDING', 'INACTIVE', 'ARCHIVED'],
      },
    },
  },
  'PATCH /api/v1/employees/{employeeId}/work-profile': {
    type: 'object',
    required: ['version'],
    properties: {
      version: { type: 'integer', minimum: 1 },
      workName: { type: 'string' },
      jobTitle: { type: 'string' },
      departmentId: { type: 'string', format: 'uuid' },
      primaryTeamId: { type: ['string', 'null'], format: 'uuid' },
      additionalTeamIds: { type: 'array', items: { type: 'string', format: 'uuid' } },
      jobFunctionId: { type: ['string', 'null'], format: 'uuid' },
      specialisationId: { type: ['string', 'null'], format: 'uuid' },
      seniorityId: { type: 'string', format: 'uuid' },
      locationId: { type: 'string', format: 'uuid' },
      employmentType: {
        type: 'string',
        enum: ['FULL_TIME', 'PART_TIME', 'CONTRACTOR', 'INTERN', 'TEMPORARY'],
      },
      externalEmployee: { type: 'boolean' },
      lineManagerId: { type: ['string', 'null'], format: 'uuid' },
      functionalManagerId: { type: ['string', 'null'], format: 'uuid' },
      buddyId: { type: ['string', 'null'], format: 'uuid' },
      contractEndDate: { type: ['string', 'null'], format: 'date' },
      positionId: { type: ['string', 'null'], format: 'uuid' },
      workTelegram: { type: ['string', 'null'], maxLength: 200 },
      personalTelegram: { type: ['string', 'null'], maxLength: 200 },
      workFormat: { type: 'string', enum: ['OFFICE', 'REMOTE', 'HYBRID'] },
      status: {
        type: 'string',
        enum: ['JOINING', 'PROBATION', 'ACTIVE', 'ON_LEAVE', 'OFFBOARDING', 'INACTIVE', 'ARCHIVED'],
      },
      startDate: { type: 'string', format: 'date' },
      reason: { type: 'string', minLength: 1, maxLength: 2000 },
    },
  },
  'POST /api/v1/employees/{employeeId}/change-work-email': {
    type: 'object',
    required: ['version', 'workEmail', 'reason'],
    properties: {
      version: { type: 'integer', minimum: 1 },
      workEmail: { type: 'string', format: 'email', maxLength: 320 },
      reason: { type: 'string', minLength: 1, maxLength: 2000 },
    },
  },
  'POST /api/v1/employees/{employeeId}/activate': {
    type: 'object',
    required: ['version'],
    properties: { version: { type: 'integer', minimum: 1 } },
  },
  'POST /api/v1/employees/{employeeId}/rehire': {
    type: 'object',
    required: ['version', 'startDate', 'departmentId', 'seniorityId', 'locationId', 'reason'],
    properties: {
      version: { type: 'integer', minimum: 1 },
      startDate: { type: 'string', format: 'date', pattern: '^\\d{4}-\\d{2}-\\d{2}$' },
      departmentId: { type: 'string', format: 'uuid' },
      primaryTeamId: { type: ['string', 'null'], format: 'uuid' },
      jobFunctionId: { type: ['string', 'null'], format: 'uuid' },
      specialisationId: { type: ['string', 'null'], format: 'uuid' },
      seniorityId: { type: 'string', format: 'uuid' },
      locationId: { type: 'string', format: 'uuid' },
      reason: { type: 'string' },
      additionalTeamIds: { type: 'array', items: { type: 'string', format: 'uuid' } },
      positionId: { type: ['string', 'null'], format: 'uuid' },
      workTelegram: { type: ['string', 'null'], maxLength: 200 },
      personalTelegram: { type: ['string', 'null'], maxLength: 200 },
      workFormat: { type: 'string', enum: ['OFFICE', 'REMOTE', 'HYBRID'] },
      status: {
        type: 'string',
        enum: ['JOINING', 'PROBATION', 'ACTIVE', 'ON_LEAVE', 'OFFBOARDING', 'INACTIVE', 'ARCHIVED'],
      },
      employmentType: {
        type: 'string',
        enum: ['FULL_TIME', 'PART_TIME', 'CONTRACTOR', 'INTERN', 'TEMPORARY'],
      },
    },
  },
  'PATCH /api/v1/employees/{employeeId}/personal-details': {
    type: 'object',
    required: ['version'],
    properties: {
      version: { type: 'integer', minimum: 1 },
      legalFirstName: { type: 'string' },
      legalLastName: { type: 'string' },
      preferredName: { type: ['string', 'null'] },
      birthDate: { type: ['string', 'null'], format: 'date' },
      nationality: { type: ['string', 'null'] },
      personalEmail: { type: ['string', 'null'], format: 'email' },
      personalPhone: { type: ['string', 'null'] },
    },
  },
  'POST /api/v1/employees/{employeeId}/documents': {
    type: 'object',
    required: ['version', 'fileId', 'type', 'expiresAt'],
    properties: {
      version: { type: 'integer', minimum: 1 },
      fileId: { type: 'string', format: 'uuid' },
      type: { type: 'string' },
      expiresAt: { type: ['string', 'null'], format: 'date' },
    },
  },
  'POST /api/v1/employees/{employeeId}/screenings': {
    type: 'object',
    required: ['type', 'status', 'completedAt', 'externalReference'],
    properties: {
      type: { type: 'string' },
      status: { type: 'string', enum: ['PENDING', 'PASSED', 'FAILED'] },
      completedAt: { type: ['string', 'null'], format: 'date-time' },
      externalReference: { type: ['string', 'null'] },
    },
  },
  'POST /api/v1/employees/{employeeId}/right-to-work': {
    type: 'object',
    required: ['country', 'basisType', 'status', 'checkedAt', 'expiresOn'],
    properties: {
      country: { type: 'string' },
      basisType: { type: 'string' },
      status: { type: 'string', enum: ['PENDING', 'VERIFIED', 'REJECTED'] },
      checkedAt: { type: ['string', 'null'], format: 'date-time' },
      expiresOn: { type: ['string', 'null'], format: 'date' },
    },
  },
  'POST /api/v1/employees/{employeeId}/compensation': {
    type: 'object',
    required: ['amount', 'frequency', 'effectiveDate', 'reason'],
    properties: {
      amount: {
        type: 'object',
        required: ['amount', 'currency'],
        properties: {
          amount: { type: 'string', pattern: '^-?\\d+(\\.\\d{1,4})?$' },
          currency: { type: 'string', pattern: '^[A-Z]{3}$' },
        },
      },
      frequency: { type: 'string', enum: ['HOURLY', 'MONTHLY', 'ANNUAL'] },
      effectiveDate: { type: 'string', format: 'date', pattern: '^\\d{4}-\\d{2}-\\d{2}$' },
      reason: { type: 'string' },
    },
  },
  'POST /api/v1/employees/{employeeId}/payroll': {
    type: 'object',
    required: ['providerReference', 'payrollGroup', 'effectiveFrom', 'effectiveTo'],
    properties: {
      providerReference: { type: ['string', 'null'] },
      payrollGroup: { type: 'string' },
      effectiveFrom: { type: 'string', format: 'date', pattern: '^\\d{4}-\\d{2}-\\d{2}$' },
      effectiveTo: { type: ['string', 'null'], format: 'date' },
    },
  },
  'POST /api/v1/requisitions': {
    type: 'object',
    required: [
      'title',
      'organizationId',
      'departmentId',
      'minSeniorityId',
      'maxSeniorityId',
      'locationIds',
      'hiringManagerIds',
      'recruiterId',
      'headcountAllocationIds',
      'hiringReason',
      'targetStartDate',
    ],
    properties: {
      title: { type: 'string' },
      organizationId: { type: 'string', format: 'uuid' },
      departmentId: { type: 'string', format: 'uuid' },
      jobFunctionId: { type: ['string', 'null'], format: 'uuid' },
      specialisationId: { type: ['string', 'null'], format: 'uuid' },
      minSeniorityId: { type: 'string', format: 'uuid' },
      maxSeniorityId: { type: 'string', format: 'uuid' },
      locationIds: { type: 'array', minItems: 1, items: { type: 'string', format: 'uuid' } },
      hiringManagerIds: { type: 'array', minItems: 1, items: { type: 'string', format: 'uuid' } },
      recruiterId: { type: ['string', 'null'], format: 'uuid' },
      headcountAllocationIds: {
        type: 'array',
        minItems: 1,
        items: { type: 'string', format: 'uuid' },
      },
      hiringReason: { type: 'string' },
      targetStartDate: { type: 'string', format: 'date', pattern: '^\\d{4}-\\d{2}-\\d{2}$' },
      positionId: { type: ['string', 'null'], format: 'uuid' },
    },
  },
  'PATCH /api/v1/requisitions/{id}': {
    type: 'object',
    required: ['version'],
    properties: {
      version: { type: 'integer', minimum: 1 },
      title: { type: 'string' },
      recruiterId: { type: ['string', 'null'], format: 'uuid' },
      hiringManagerIds: { type: 'array', items: { type: 'string', format: 'uuid' } },
      targetStartDate: { type: 'string', format: 'date', pattern: '^\\d{4}-\\d{2}-\\d{2}$' },
      hiringReason: { type: 'string' },
      positionId: { type: ['string', 'null'], format: 'uuid' },
    },
  },
  'POST /api/v1/headcount-allocations': {
    type: 'object',
    required: ['organizationId', 'departmentId', 'code', 'effectiveFrom'],
    properties: {
      organizationId: { type: 'string', format: 'uuid' },
      departmentId: { type: 'string', format: 'uuid' },
      code: { type: 'string' },
      effectiveFrom: { type: 'string', format: 'date', pattern: '^\\d{4}-\\d{2}-\\d{2}$' },
      positionId: { type: ['string', 'null'], format: 'uuid' },
    },
  },
  'POST /api/v1/requisitions/{id}/submit': {
    type: 'object',
    required: ['version'],
    properties: { version: { type: 'integer', minimum: 1 } },
  },
  'POST /api/v1/requisitions/{id}/approve': {
    type: 'object',
    required: ['version', 'comment'],
    properties: {
      version: { type: 'integer', minimum: 1 },
      comment: { type: ['string', 'null'], maxLength: 4000 },
    },
  },
  'POST /api/v1/requisitions/{id}/reject': {
    type: 'object',
    required: ['version', 'comment'],
    properties: {
      version: { type: 'integer', minimum: 1 },
      comment: { type: ['string', 'null'], maxLength: 4000 },
    },
  },
  'POST /api/v1/requisitions/{id}/hold': {
    type: 'object',
    required: ['version', 'reason'],
    properties: {
      version: { type: 'integer', minimum: 1 },
      reason: { type: 'string', minLength: 1, maxLength: 2000 },
    },
  },
  'POST /api/v1/requisitions/{id}/resume': {
    type: 'object',
    required: ['version'],
    properties: { version: { type: 'integer', minimum: 1 } },
  },
  'POST /api/v1/requisitions/{id}/close': {
    type: 'object',
    required: ['version', 'outcome', 'reason'],
    properties: {
      version: { type: 'integer', minimum: 1 },
      outcome: { type: 'string', enum: ['HIRED', 'CANCELLED', 'FROZEN', 'CLOSED_WITHOUT_HIRE'] },
      reason: { type: 'string', minLength: 1, maxLength: 2000 },
      positionId: { type: ['string', 'null'], format: 'uuid' },
    },
  },
  'POST /api/v1/requisitions/{id}/reopen': {
    type: 'object',
    required: ['version', 'reason'],
    properties: {
      version: { type: 'integer', minimum: 1 },
      reason: { type: 'string', minLength: 1, maxLength: 2000 },
    },
  },
  'POST /api/v1/requisitions/{id}/archive': {
    type: 'object',
    required: ['version', 'reason'],
    properties: {
      version: { type: 'integer', minimum: 1 },
      reason: { type: 'string', minLength: 1, maxLength: 2000 },
    },
  },
  'POST /api/v1/job-postings': {
    type: 'object',
    required: [
      'internalTitle',
      'publicTitle',
      'description',
      'confidential',
      'audience',
      'minSeniorityId',
      'maxSeniorityId',
      'locationIds',
      'recruiterId',
      'hiringManagerIds',
      'requisitionIds',
    ],
    properties: {
      internalTitle: { type: 'string' },
      publicTitle: { type: 'string' },
      description: { type: 'string' },
      confidential: { type: 'boolean' },
      audience: { type: 'string', enum: ['INTERNAL', 'PUBLIC', 'BOTH'] },
      jobFunctionId: { type: ['string', 'null'], format: 'uuid' },
      specialisationId: { type: ['string', 'null'], format: 'uuid' },
      minSeniorityId: { type: 'string', format: 'uuid' },
      maxSeniorityId: { type: 'string', format: 'uuid' },
      locationIds: { type: 'array', minItems: 1, items: { type: 'string', format: 'uuid' } },
      recruiterId: { type: ['string', 'null'], format: 'uuid' },
      hiringManagerIds: { type: 'array', minItems: 1, items: { type: 'string', format: 'uuid' } },
      requisitionIds: { type: 'array', minItems: 1, items: { type: 'string', format: 'uuid' } },
      positionId: { type: ['string', 'null'], format: 'uuid' },
    },
  },
  'PATCH /api/v1/job-postings/{id}': {
    type: 'object',
    required: ['version'],
    properties: {
      version: { type: 'integer', minimum: 1 },
      internalTitle: { type: 'string' },
      publicTitle: { type: 'string' },
      description: { type: 'string' },
      confidential: { type: 'boolean' },
      audience: { type: 'string', enum: ['INTERNAL', 'PUBLIC', 'BOTH'] },
      recruiterId: { type: ['string', 'null'], format: 'uuid' },
      hiringManagerIds: { type: 'array', items: { type: 'string', format: 'uuid' } },
      positionId: { type: ['string', 'null'], format: 'uuid' },
    },
  },
  'POST /api/v1/job-postings/{id}/application-form-versions': {
    type: 'object',
    required: ['version', 'sections'],
    properties: {
      version: { type: 'integer', minimum: 1 },
      sections: {
        type: 'array',
        minItems: 1,
        items: {
          type: 'object',
          required: ['id', 'title', 'order', 'questions'],
          properties: {
            id: { type: 'string', format: 'uuid' },
            title: { type: 'string' },
            order: { type: 'integer', minimum: 0 },
            questions: {
              type: 'array',
              items: {
                type: 'object',
                required: ['id', 'key', 'label', 'required', 'type', 'minLength', 'maxLength'],
                properties: {
                  id: { type: 'string', format: 'uuid' },
                  key: { type: 'string', pattern: '^[a-z][a-z0-9_]*$' },
                  label: { type: 'string', minLength: 1, maxLength: 500 },
                  required: { type: 'boolean' },
                  type: { type: 'string', enum: ['SHORT_TEXT', 'LONG_TEXT'] },
                  minLength: { type: 'integer', minimum: 0 },
                  maxLength: { type: 'integer', minimum: 1 },
                },
                variants: [
                  {
                    type: 'object',
                    required: ['id', 'key', 'label', 'required', 'type', 'minLength', 'maxLength'],
                    properties: {
                      id: { type: 'string', format: 'uuid' },
                      key: { type: 'string', pattern: '^[a-z][a-z0-9_]*$' },
                      label: { type: 'string', minLength: 1, maxLength: 500 },
                      required: { type: 'boolean' },
                      type: { type: 'string', enum: ['SHORT_TEXT', 'LONG_TEXT'] },
                      minLength: { type: 'integer', minimum: 0 },
                      maxLength: { type: 'integer', minimum: 1 },
                    },
                  },
                  {
                    type: 'object',
                    required: ['id', 'key', 'label', 'required', 'type', 'options'],
                    properties: {
                      id: { type: 'string', format: 'uuid' },
                      key: { type: 'string', pattern: '^[a-z][a-z0-9_]*$' },
                      label: { type: 'string', minLength: 1, maxLength: 500 },
                      required: { type: 'boolean' },
                      type: { type: 'string', enum: ['SINGLE_CHOICE', 'MULTI_CHOICE'] },
                      options: {
                        type: 'array',
                        minItems: 1,
                        items: {
                          type: 'object',
                          required: ['value', 'label'],
                          properties: { value: { type: 'string' }, label: { type: 'string' } },
                        },
                      },
                    },
                  },
                  {
                    type: 'object',
                    required: ['id', 'key', 'label', 'required', 'type', 'min', 'max'],
                    properties: {
                      id: { type: 'string', format: 'uuid' },
                      key: { type: 'string', pattern: '^[a-z][a-z0-9_]*$' },
                      label: { type: 'string', minLength: 1, maxLength: 500 },
                      required: { type: 'boolean' },
                      type: { type: 'string', enum: ['DATE'] },
                      min: { type: ['string', 'null'], format: 'date' },
                      max: { type: ['string', 'null'], format: 'date' },
                    },
                  },
                  {
                    type: 'object',
                    required: ['id', 'key', 'label', 'required', 'type'],
                    properties: {
                      id: { type: 'string', format: 'uuid' },
                      key: { type: 'string', pattern: '^[a-z][a-z0-9_]*$' },
                      label: { type: 'string', minLength: 1, maxLength: 500 },
                      required: { type: 'boolean' },
                      type: { type: 'string', enum: ['BOOLEAN'] },
                    },
                  },
                  {
                    type: 'object',
                    required: [
                      'id',
                      'key',
                      'label',
                      'required',
                      'type',
                      'allowedMimeTypes',
                      'maxFiles',
                      'maxFileSizeBytes',
                    ],
                    properties: {
                      id: { type: 'string', format: 'uuid' },
                      key: { type: 'string', pattern: '^[a-z][a-z0-9_]*$' },
                      label: { type: 'string', minLength: 1, maxLength: 500 },
                      required: { type: 'boolean' },
                      type: { type: 'string', enum: ['FILE'] },
                      allowedMimeTypes: { type: 'array', items: { type: 'string' } },
                      maxFiles: { type: 'integer', minimum: 1, maximum: 10 },
                      maxFileSizeBytes: { type: 'integer', minimum: 1, maximum: 52428800 },
                    },
                  },
                ],
                discriminator: 'type',
                nullable: false,
              },
            },
          },
        },
      },
    },
  },
  'POST /api/v1/job-postings/{id}/pipeline-versions': {
    type: 'object',
    required: ['version', 'stages'],
    properties: {
      version: { type: 'integer', minimum: 1 },
      stages: {
        type: 'array',
        minItems: 1,
        items: {
          type: 'object',
          required: ['id', 'name', 'type', 'order', 'scorecardTemplateVersionId'],
          properties: {
            id: { type: 'string', format: 'uuid' },
            name: { type: 'string' },
            type: { type: 'string', enum: ['SCREENING', 'INTERVIEW', 'ASSESSMENT', 'OFFER'] },
            order: { type: 'integer', minimum: 0 },
            scorecardTemplateVersionId: { type: ['string', 'null'], format: 'uuid' },
          },
        },
      },
    },
  },
  'POST /api/v1/job-postings/{id}/submit-approval': {
    type: 'object',
    required: ['version'],
    properties: { version: { type: 'integer', minimum: 1 } },
  },
  'POST /api/v1/job-postings/{id}/approve': {
    type: 'object',
    required: ['version', 'comment'],
    properties: {
      version: { type: 'integer', minimum: 1 },
      comment: { type: ['string', 'null'], maxLength: 4000 },
    },
  },
  'POST /api/v1/job-postings/{id}/reject': {
    type: 'object',
    required: ['version', 'comment'],
    properties: {
      version: { type: 'integer', minimum: 1 },
      comment: { type: ['string', 'null'], maxLength: 4000 },
    },
  },
  'POST /api/v1/job-postings/{id}/publish': {
    type: 'object',
    required: ['version', 'channels'],
    properties: {
      version: { type: 'integer', minimum: 1 },
      channels: {
        type: 'array',
        minItems: 1,
        items: { type: 'string', enum: ['INTERNAL', 'PUBLIC'] },
      },
      positionId: { type: ['string', 'null'], format: 'uuid' },
    },
  },
  'POST /api/v1/job-postings/{id}/unpublish': {
    type: 'object',
    required: ['version', 'channels'],
    properties: {
      version: { type: 'integer', minimum: 1 },
      channels: {
        type: 'array',
        minItems: 1,
        items: { type: 'string', enum: ['INTERNAL', 'PUBLIC'] },
      },
      positionId: { type: ['string', 'null'], format: 'uuid' },
    },
  },
  'POST /api/v1/job-postings/{id}/hold': {
    type: 'object',
    required: ['version', 'reason'],
    properties: {
      version: { type: 'integer', minimum: 1 },
      reason: { type: 'string', minLength: 1, maxLength: 2000 },
    },
  },
  'POST /api/v1/job-postings/{id}/resume': {
    type: 'object',
    required: ['version'],
    properties: { version: { type: 'integer', minimum: 1 } },
  },
  'POST /api/v1/job-postings/{id}/close': {
    type: 'object',
    required: ['version', 'reason', 'result'],
    properties: {
      version: { type: 'integer', minimum: 1 },
      reason: { type: 'string' },
      result: { type: 'string', enum: ['FILLED', 'CANCELLED', 'CLOSED_WITHOUT_HIRE'] },
      positionId: { type: ['string', 'null'], format: 'uuid' },
    },
  },
  'POST /api/v1/job-postings/{id}/reopen': {
    type: 'object',
    required: ['version', 'reason'],
    properties: {
      version: { type: 'integer', minimum: 1 },
      reason: { type: 'string', minLength: 1, maxLength: 2000 },
    },
  },
  'POST /api/v1/job-postings/{id}/archive': {
    type: 'object',
    required: ['version', 'reason'],
    properties: {
      version: { type: 'integer', minimum: 1 },
      reason: { type: 'string', minLength: 1, maxLength: 2000 },
    },
  },
  'POST /api/v1/candidates': {
    type: 'object',
    required: [
      'name',
      'primaryEmail',
      'country',
      'phone',
      'source',
      'purpose',
      'jurisdiction',
      'privacyNoticeDelivery',
      'consentEvidence',
    ],
    properties: {
      name: { type: 'string' },
      primaryEmail: { type: 'string', format: 'email', maxLength: 320 },
      country: { type: 'string' },
      phone: { type: ['string', 'null'] },
      source: { type: 'string', enum: ['DIRECT_APPLICATION', 'RECRUITER', 'IMPORT', 'REFERRAL'] },
      purpose: { type: 'string' },
      jurisdiction: { type: 'string' },
      privacyNoticeDelivery: {
        type: 'object',
        required: ['privacyNoticeVersionId', 'deliveredAt', 'channel'],
        properties: {
          privacyNoticeVersionId: { type: 'string', format: 'uuid' },
          deliveredAt: { type: 'string', format: 'date-time' },
          channel: { type: 'string', enum: ['PUBLIC_FORM', 'EMAIL', 'RECRUITER', 'IMPORT'] },
        },
        nullable: true,
      },
      consentEvidence: {
        type: 'object',
        required: ['grantedAt', 'channel', 'policyVersion', 'evidenceTextHash'],
        properties: {
          grantedAt: { type: 'string', format: 'date-time' },
          channel: { type: 'string', enum: ['PUBLIC_FORM', 'EMAIL', 'RECORDED_BY_RECRUITER'] },
          policyVersion: { type: 'string' },
          evidenceTextHash: { type: 'string' },
        },
        nullable: true,
      },
    },
  },
  'PATCH /api/v1/candidates/{id}': {
    type: 'object',
    required: ['version'],
    properties: {
      version: { type: 'integer', minimum: 1 },
      name: { type: 'string' },
      primaryEmail: { type: 'string', format: 'email', maxLength: 320 },
      country: { type: 'string' },
      phone: { type: ['string', 'null'] },
      tags: { type: 'array', items: { type: 'string' } },
      currentEmployer: { type: ['string', 'null'] },
    },
  },
  'POST /api/v1/candidates/imports': {
    type: 'object',
    required: ['fileId', 'organizationId', 'dryRun', 'source', 'purpose', 'jurisdiction'],
    properties: {
      fileId: { type: 'string', format: 'uuid' },
      organizationId: { type: 'string', format: 'uuid' },
      dryRun: { type: 'boolean' },
      source: { type: 'string', enum: ['DIRECT_APPLICATION', 'RECRUITER', 'IMPORT', 'REFERRAL'] },
      purpose: { type: 'string' },
      jurisdiction: { type: 'string' },
    },
  },
  'POST /api/v1/candidates/merge': {
    type: 'object',
    required: ['primaryCandidateId', 'mergedCandidateIds', 'version', 'reason'],
    properties: {
      primaryCandidateId: { type: 'string', format: 'uuid' },
      mergedCandidateIds: { type: 'array', minItems: 1, items: { type: 'string', format: 'uuid' } },
      version: { type: 'integer', minimum: 1 },
      reason: { type: 'string' },
    },
  },
  'POST /api/v1/privacy-notice-versions': {
    type: 'object',
    required: ['jurisdiction', 'language', 'purpose', 'text'],
    properties: {
      jurisdiction: { type: 'string' },
      language: { type: 'string' },
      purpose: { type: 'string' },
      text: { type: 'string', minLength: 1 },
    },
  },
  'POST /api/v1/privacy-notice-versions/{id}/publish': {
    type: 'object',
    required: ['version'],
    properties: { version: { type: 'integer', minimum: 1 } },
  },
  'POST /api/v1/processing-basis-policy-versions': {
    type: 'object',
    required: ['legalApprovalReference', 'rules'],
    properties: {
      legalApprovalReference: { type: 'string' },
      rules: {
        type: 'array',
        minItems: 1,
        items: {
          type: 'object',
          required: [
            'source',
            'purpose',
            'jurisdiction',
            'basis',
            'consentRequired',
            'noticeVersionId',
            'expiresAfterDays',
          ],
          properties: {
            source: {
              type: 'string',
              enum: ['DIRECT_APPLICATION', 'RECRUITER', 'IMPORT', 'REFERRAL'],
            },
            purpose: { type: 'string' },
            jurisdiction: { type: 'string' },
            basis: {
              type: 'string',
              enum: ['CONSENT', 'PRE_CONTRACTUAL', 'LEGITIMATE_INTEREST', 'LEGAL_OBLIGATION'],
            },
            consentRequired: { type: 'boolean' },
            noticeVersionId: { type: 'string', format: 'uuid' },
            expiresAfterDays: { type: ['integer', 'null'], minimum: 1 },
          },
        },
      },
    },
  },
  'POST /api/v1/processing-basis-policy-versions/{id}/activate': {
    type: 'object',
    required: ['version', 'effectiveAt'],
    properties: {
      version: { type: 'integer', minimum: 1 },
      effectiveAt: { type: 'string', format: 'date-time' },
    },
  },
  'POST /api/v1/candidates/{id}/processing-purposes': {
    type: 'object',
    required: ['source', 'purpose', 'jurisdiction', 'privacyNoticeDelivery', 'consentEvidence'],
    properties: {
      source: { type: 'string', enum: ['DIRECT_APPLICATION', 'RECRUITER', 'IMPORT', 'REFERRAL'] },
      purpose: { type: 'string' },
      jurisdiction: { type: 'string' },
      privacyNoticeDelivery: {
        type: 'object',
        required: ['privacyNoticeVersionId', 'deliveredAt', 'channel'],
        properties: {
          privacyNoticeVersionId: { type: 'string', format: 'uuid' },
          deliveredAt: { type: 'string', format: 'date-time' },
          channel: { type: 'string', enum: ['PUBLIC_FORM', 'EMAIL', 'RECRUITER', 'IMPORT'] },
        },
        nullable: true,
      },
      consentEvidence: {
        type: 'object',
        required: ['grantedAt', 'channel', 'policyVersion', 'evidenceTextHash'],
        properties: {
          grantedAt: { type: 'string', format: 'date-time' },
          channel: { type: 'string', enum: ['PUBLIC_FORM', 'EMAIL', 'RECORDED_BY_RECRUITER'] },
          policyVersion: { type: 'string' },
          evidenceTextHash: { type: 'string' },
        },
        nullable: true,
      },
    },
  },
  'POST /api/v1/candidates/{id}/privacy-notice-deliveries': {
    type: 'object',
    required: ['privacyNoticeVersionId', 'deliveredAt', 'channel'],
    properties: {
      privacyNoticeVersionId: { type: 'string', format: 'uuid' },
      deliveredAt: { type: 'string', format: 'date-time' },
      channel: { type: 'string', enum: ['PUBLIC_FORM', 'EMAIL', 'RECRUITER', 'IMPORT'] },
    },
  },
  'POST /api/v1/candidates/{id}/consents': {
    type: 'object',
    required: ['processingBasisRecordId', 'evidence'],
    properties: {
      processingBasisRecordId: { type: 'string', format: 'uuid' },
      evidence: {
        type: 'object',
        required: ['grantedAt', 'channel', 'policyVersion', 'evidenceTextHash'],
        properties: {
          grantedAt: { type: 'string', format: 'date-time' },
          channel: { type: 'string', enum: ['PUBLIC_FORM', 'EMAIL', 'RECORDED_BY_RECRUITER'] },
          policyVersion: { type: 'string' },
          evidenceTextHash: { type: 'string' },
        },
      },
    },
  },
  'POST /api/v1/candidate-consents/{id}/revoke': {
    type: 'object',
    required: ['version', 'reason', 'channel'],
    properties: {
      version: { type: 'integer', minimum: 1 },
      reason: { type: 'string' },
      channel: { type: 'string', enum: ['INTERNAL', 'CANDIDATE_REQUEST'] },
    },
  },
  'POST /api/v1/applications': {
    type: 'object',
    required: ['candidateId', 'jobPostingId', 'purpose', 'jurisdiction', 'answers'],
    properties: {
      candidateId: { type: 'string', format: 'uuid' },
      jobPostingId: { type: 'string', format: 'uuid' },
      purpose: { type: 'string' },
      jurisdiction: { type: 'string' },
      answers: {
        type: 'array',
        items: {
          type: 'object',
          required: ['questionId', 'type', 'value'],
          properties: {
            questionId: { type: 'string', format: 'uuid' },
            type: { type: 'string', enum: ['SHORT_TEXT', 'LONG_TEXT'] },
            value: { type: 'string' },
          },
          variants: [
            {
              type: 'object',
              required: ['questionId', 'type', 'value'],
              properties: {
                questionId: { type: 'string', format: 'uuid' },
                type: { type: 'string', enum: ['SHORT_TEXT', 'LONG_TEXT'] },
                value: { type: 'string' },
              },
            },
            {
              type: 'object',
              required: ['questionId', 'type', 'values'],
              properties: {
                questionId: { type: 'string', format: 'uuid' },
                type: { type: 'string', enum: ['SINGLE_CHOICE', 'MULTI_CHOICE'] },
                values: { type: 'array', items: { type: 'string' } },
              },
            },
            {
              type: 'object',
              required: ['questionId', 'type', 'value'],
              properties: {
                questionId: { type: 'string', format: 'uuid' },
                type: { type: 'string', enum: ['DATE'] },
                value: { type: 'string', format: 'date', pattern: '^\\d{4}-\\d{2}-\\d{2}$' },
              },
            },
            {
              type: 'object',
              required: ['questionId', 'type', 'value'],
              properties: {
                questionId: { type: 'string', format: 'uuid' },
                type: { type: 'string', enum: ['BOOLEAN'] },
                value: { type: 'boolean' },
              },
            },
            {
              type: 'object',
              required: ['questionId', 'type', 'fileIds'],
              properties: {
                questionId: { type: 'string', format: 'uuid' },
                type: { type: 'string', enum: ['FILE'] },
                fileIds: { type: 'array', minItems: 1, items: { type: 'string', format: 'uuid' } },
              },
            },
          ],
          discriminator: 'type',
          nullable: false,
        },
      },
    },
  },
  'POST /api/v1/applications/{id}/change-stage': {
    type: 'object',
    required: ['version', 'toStageId', 'reason', 'comment'],
    properties: {
      version: { type: 'integer', minimum: 1 },
      toStageId: { type: 'string', format: 'uuid' },
      reason: { type: 'string' },
      comment: { type: ['string', 'null'] },
    },
  },
  'POST /api/v1/applications/{id}/reject': {
    type: 'object',
    required: ['version', 'reason', 'comment'],
    properties: {
      version: { type: 'integer', minimum: 1 },
      reason: { type: 'string' },
      comment: { type: ['string', 'null'] },
    },
  },
  'POST /api/v1/applications/{id}/withdraw': {
    type: 'object',
    required: ['version', 'reason', 'comment'],
    properties: {
      version: { type: 'integer', minimum: 1 },
      reason: { type: 'string' },
      comment: { type: ['string', 'null'] },
    },
  },
  'POST /api/v1/applications/{id}/archive': {
    type: 'object',
    required: ['version'],
    properties: { version: { type: 'integer', minimum: 1 } },
  },
  'POST /api/v1/applications/{id}/interviews': {
    type: 'object',
    required: ['startsAt', 'timezone', 'durationMinutes', 'interviewerIds', 'meetingUrl'],
    properties: {
      startsAt: { type: 'string', format: 'date-time' },
      timezone: { type: 'string' },
      durationMinutes: { type: 'integer', minimum: 5, maximum: 480 },
      interviewerIds: { type: 'array', minItems: 1, items: { type: 'string', format: 'uuid' } },
      meetingUrl: { type: ['string', 'null'], format: 'uri' },
    },
  },
  'POST /api/v1/interviews/{id}/reschedule': {
    type: 'object',
    required: ['version', 'startsAt', 'timezone', 'reason'],
    properties: {
      version: { type: 'integer', minimum: 1 },
      startsAt: { type: 'string', format: 'date-time' },
      timezone: { type: 'string' },
      reason: { type: 'string' },
    },
  },
  'POST /api/v1/interviews/{id}/cancel': {
    type: 'object',
    required: ['version', 'reason'],
    properties: {
      version: { type: 'integer', minimum: 1 },
      reason: { type: 'string', minLength: 1, maxLength: 2000 },
    },
  },
  'POST /api/v1/interviews/{id}/complete': {
    type: 'object',
    required: ['version', 'reason'],
    properties: {
      version: { type: 'integer', minimum: 1 },
      reason: { type: 'string', minLength: 1, maxLength: 2000 },
    },
  },
  'POST /api/v1/interviews/{id}/no-show': {
    type: 'object',
    required: ['version', 'absentParty', 'reason'],
    properties: {
      version: { type: 'integer', minimum: 1 },
      absentParty: { type: 'string', enum: ['CANDIDATE', 'INTERVIEWER', 'BOTH'] },
      reason: { type: 'string' },
    },
  },
  'POST /api/v1/interviews/{id}/feedback': {
    type: 'object',
    required: ['version', 'recommendation', 'scorecardTemplateVersionId', 'answers'],
    properties: {
      version: { type: 'integer', minimum: 1 },
      recommendation: {
        type: 'string',
        enum: ['STRONG_HIRE', 'HIRE', 'NO_HIRE', 'STRONG_NO_HIRE'],
      },
      scorecardTemplateVersionId: { type: ['string', 'null'], format: 'uuid' },
      answers: {
        type: 'array',
        items: {
          type: 'object',
          required: ['criterionId', 'score', 'comment'],
          properties: {
            criterionId: { type: 'string', format: 'uuid' },
            score: { type: 'integer', minimum: 1, maximum: 5 },
            comment: { type: ['string', 'null'] },
          },
        },
      },
    },
  },
  'POST /api/v1/applications/{id}/offers': {
    type: 'object',
    required: ['title', 'body', 'compensation', 'startDate', 'expiresAt'],
    properties: {
      title: { type: 'string' },
      body: { type: 'string' },
      compensation: {
        type: 'object',
        required: ['amount', 'currency'],
        properties: {
          amount: { type: 'string', pattern: '^-?\\d+(\\.\\d{1,4})?$' },
          currency: { type: 'string', pattern: '^[A-Z]{3}$' },
        },
      },
      startDate: { type: 'string', format: 'date', pattern: '^\\d{4}-\\d{2}-\\d{2}$' },
      expiresAt: { type: 'string', format: 'date-time' },
    },
  },
  'POST /api/v1/offers/{id}/versions': {
    type: 'object',
    required: ['version', 'title', 'body', 'compensation', 'startDate', 'expiresAt'],
    properties: {
      version: { type: 'integer', minimum: 1 },
      title: { type: 'string' },
      body: { type: 'string' },
      compensation: {
        type: 'object',
        required: ['amount', 'currency'],
        properties: {
          amount: { type: 'string', pattern: '^-?\\d+(\\.\\d{1,4})?$' },
          currency: { type: 'string', pattern: '^[A-Z]{3}$' },
        },
      },
      startDate: { type: 'string', format: 'date', pattern: '^\\d{4}-\\d{2}-\\d{2}$' },
      expiresAt: { type: 'string', format: 'date-time' },
    },
  },
  'POST /api/v1/offers/{id}/submit-approval': {
    type: 'object',
    required: ['version'],
    properties: { version: { type: 'integer', minimum: 1 } },
  },
  'POST /api/v1/offers/{id}/approve': {
    type: 'object',
    required: ['version', 'comment'],
    properties: {
      version: { type: 'integer', minimum: 1 },
      comment: { type: ['string', 'null'], maxLength: 4000 },
    },
  },
  'POST /api/v1/offers/{id}/reject': {
    type: 'object',
    required: ['version', 'comment'],
    properties: {
      version: { type: 'integer', minimum: 1 },
      comment: { type: ['string', 'null'], maxLength: 4000 },
    },
  },
  'POST /api/v1/offers/{id}/send': {
    type: 'object',
    required: ['version', 'recipientEmail'],
    properties: {
      version: { type: 'integer', minimum: 1 },
      recipientEmail: { type: 'string', format: 'email', maxLength: 320 },
      emailTemplateVersionId: { type: 'string', format: 'uuid' },
    },
  },
  'POST /api/v1/offers/{id}/withdraw': {
    type: 'object',
    required: ['version', 'reason'],
    properties: {
      version: { type: 'integer', minimum: 1 },
      reason: { type: 'string', minLength: 1, maxLength: 2000 },
    },
  },
  'POST /api/v1/applications/{id}/hire': {
    type: 'object',
    required: ['applicationVersion', 'employee'],
    properties: {
      applicationVersion: { type: 'integer', minimum: 1 },
      employee: {
        type: 'object',
        required: [
          'workName',
          'workEmail',
          'organizationId',
          'departmentId',
          'seniorityId',
          'locationId',
          'startDate',
        ],
        properties: {
          employeeNumber: { type: 'string' },
          workName: { type: 'string' },
          workEmail: { type: 'string', format: 'email', maxLength: 320 },
          jobTitle: { type: 'string' },
          organizationId: { type: 'string', format: 'uuid' },
          departmentId: { type: 'string', format: 'uuid' },
          primaryTeamId: { type: ['string', 'null'], format: 'uuid' },
          additionalTeamIds: { type: 'array', items: { type: 'string', format: 'uuid' } },
          jobFunctionId: { type: ['string', 'null'], format: 'uuid' },
          specialisationId: { type: ['string', 'null'], format: 'uuid' },
          seniorityId: { type: 'string', format: 'uuid' },
          locationId: { type: 'string', format: 'uuid' },
          employmentType: { type: 'string', enum: ['FULL_TIME', 'PART_TIME', 'CONTRACTOR'] },
          externalEmployee: { type: 'boolean' },
          lineManagerId: { type: ['string', 'null'], format: 'uuid' },
          functionalManagerId: { type: ['string', 'null'], format: 'uuid' },
          buddyId: { type: ['string', 'null'], format: 'uuid' },
          startDate: { type: 'string', format: 'date', pattern: '^\\d{4}-\\d{2}-\\d{2}$' },
          contractEndDate: { type: ['string', 'null'], format: 'date' },
          positionId: { type: ['string', 'null'], format: 'uuid' },
          workTelegram: { type: ['string', 'null'], maxLength: 200 },
          personalTelegram: { type: ['string', 'null'], maxLength: 200 },
          workFormat: { type: 'string', enum: ['OFFICE', 'REMOTE', 'HYBRID'] },
          status: {
            type: 'string',
            enum: [
              'JOINING',
              'PROBATION',
              'ACTIVE',
              'ON_LEAVE',
              'OFFBOARDING',
              'INACTIVE',
              'ARCHIVED',
            ],
          },
        },
      },
    },
  },
  'POST /api/v1/process-templates': {
    type: 'object',
    required: ['name', 'type', 'organizationId'],
    properties: {
      name: { type: 'string' },
      type: { type: 'string', enum: ['ONBOARDING', 'OFFBOARDING'] },
      organizationId: { type: 'string', format: 'uuid' },
    },
  },
  'POST /api/v1/process-templates/{id}/versions': {
    type: 'object',
    required: ['version', 'stages'],
    properties: {
      version: { type: 'integer', minimum: 1 },
      stages: {
        type: 'array',
        minItems: 1,
        items: {
          type: 'object',
          required: ['key', 'title', 'order', 'tasks'],
          properties: {
            key: { type: 'string' },
            title: { type: 'string' },
            order: { type: 'integer', minimum: 0 },
            tasks: {
              type: 'array',
              items: {
                type: 'object',
                required: [
                  'key',
                  'title',
                  'order',
                  'required',
                  'assigneeRule',
                  'dependencyKeys',
                  'taskType',
                ],
                properties: {
                  key: { type: 'string' },
                  title: { type: 'string' },
                  order: { type: 'integer', minimum: 0 },
                  required: { type: 'boolean' },
                  assigneeRule: {
                    type: 'string',
                    enum: [
                      'HR',
                      'LINE_MANAGER',
                      'FUNCTIONAL_MANAGER',
                      'BUDDY',
                      'OWNER',
                      'PERMISSION_GROUP',
                    ],
                  },
                  dependencyKeys: { type: 'array', items: { type: 'string' } },
                  taskType: {
                    type: 'string',
                    enum: [
                      'ACTION',
                      'FORM',
                      'DOCUMENT',
                      'SCREENING',
                      'RIGHT_TO_WORK',
                      'CONFIRMATION',
                    ],
                  },
                },
              },
            },
          },
        },
      },
    },
  },
  'POST /api/v1/process-template-versions/{id}/publish': {
    type: 'object',
    required: ['version'],
    properties: { version: { type: 'integer', minimum: 1 } },
  },
  'POST /api/v1/onboarding-processes': {
    type: 'object',
    required: [
      'employeeId',
      'templateVersionId',
      'expectedStartDate',
      'hrOwnerId',
      'managerId',
      'buddyId',
    ],
    properties: {
      employeeId: { type: 'string', format: 'uuid' },
      templateVersionId: { type: 'string', format: 'uuid' },
      expectedStartDate: { type: 'string', format: 'date', pattern: '^\\d{4}-\\d{2}-\\d{2}$' },
      hrOwnerId: { type: 'string', format: 'uuid' },
      managerId: { type: ['string', 'null'], format: 'uuid' },
      buddyId: { type: ['string', 'null'], format: 'uuid' },
    },
  },
  'POST /api/v1/onboarding-processes/{id}/start': {
    type: 'object',
    required: ['version'],
    properties: { version: { type: 'integer', minimum: 1 } },
  },
  'POST /api/v1/onboarding-processes/{id}/complete': {
    type: 'object',
    required: ['version', 'comment'],
    properties: { version: { type: 'integer', minimum: 1 }, comment: { type: ['string', 'null'] } },
  },
  'POST /api/v1/onboarding-processes/{id}/cancel': {
    type: 'object',
    required: ['version', 'reason'],
    properties: {
      version: { type: 'integer', minimum: 1 },
      reason: { type: 'string', minLength: 1, maxLength: 2000 },
    },
  },
  'POST /api/v1/offboarding-processes': {
    type: 'object',
    required: [
      'employeeId',
      'templateVersionId',
      'terminationType',
      'reason',
      'lastWorkingDate',
      'contractEndDate',
      'accessEndsAt',
      'hrOwnerId',
    ],
    properties: {
      employeeId: { type: 'string', format: 'uuid' },
      templateVersionId: { type: 'string', format: 'uuid' },
      terminationType: { type: 'string' },
      reason: { type: 'string' },
      lastWorkingDate: { type: 'string', format: 'date', pattern: '^\\d{4}-\\d{2}-\\d{2}$' },
      contractEndDate: { type: ['string', 'null'], format: 'date' },
      accessEndsAt: { type: 'string', format: 'date-time' },
      hrOwnerId: { type: 'string', format: 'uuid' },
    },
  },
  'POST /api/v1/offboarding-processes/{id}/start': {
    type: 'object',
    required: ['version'],
    properties: { version: { type: 'integer', minimum: 1 } },
  },
  'POST /api/v1/offboarding-processes/{id}/complete': {
    type: 'object',
    required: ['version', 'comment'],
    properties: { version: { type: 'integer', minimum: 1 }, comment: { type: ['string', 'null'] } },
  },
  'POST /api/v1/offboarding-processes/{id}/cancel': {
    type: 'object',
    required: ['version', 'reason'],
    properties: {
      version: { type: 'integer', minimum: 1 },
      reason: { type: 'string', minLength: 1, maxLength: 2000 },
    },
  },
  'POST /api/v1/offboarding-processes/{id}/access-extension': {
    type: 'object',
    required: ['version', 'accessEndsAt', 'reason'],
    properties: {
      version: { type: 'integer', minimum: 1 },
      accessEndsAt: { type: 'string', format: 'date-time' },
      reason: { type: 'string' },
    },
  },
  'DELETE /api/v1/offboarding-processes/{id}/access-extension': {},
  'POST /api/v1/offboarding-processes/{id}/disable-access-now': {
    type: 'object',
    required: ['version', 'reason'],
    properties: {
      version: { type: 'integer', minimum: 1 },
      reason: { type: 'string', minLength: 1, maxLength: 2000 },
    },
  },
  'POST /api/v1/process-tasks/{id}/complete': {
    type: 'object',
    required: ['version', 'result', 'comment'],
    properties: {
      version: { type: 'integer', minimum: 1 },
      result: { type: 'object', additionalProperties: true, properties: {} },
      comment: { type: ['string', 'null'] },
    },
  },
  'POST /api/v1/files': {},
  'POST /api/v1/files/{id}/download-url': {
    type: 'object',
    required: ['fileVersionId'],
    properties: { fileVersionId: { type: 'string', format: 'uuid' } },
  },
  'POST /api/v1/exports': {
    type: 'object',
    required: ['resourceType', 'filters', 'format'],
    properties: {
      resourceType: { type: 'string' },
      filters: { type: 'object', additionalProperties: true, properties: {} },
      format: { type: 'string', enum: ['CSV', 'XLSX'] },
    },
  },
  'POST /api/v1/retention-policies': {
    type: 'object',
    required: ['dataType', 'purpose', 'jurisdiction', 'startsFrom', 'durationDays', 'action'],
    properties: {
      dataType: { type: 'string' },
      purpose: { type: 'string' },
      jurisdiction: { type: 'string' },
      startsFrom: { type: 'string' },
      durationDays: { type: 'integer', minimum: 1 },
      action: { type: 'string', enum: ['DELETE', 'ANONYMIZE', 'REVIEW'] },
    },
  },
  'PATCH /api/v1/retention-policies/{id}': {
    type: 'object',
    required: ['version'],
    properties: {
      version: { type: 'integer', minimum: 1 },
      durationDays: { type: 'integer', minimum: 1 },
      action: { type: 'string', enum: ['DELETE', 'ANONYMIZE', 'REVIEW'] },
      status: { type: 'string', enum: ['DRAFT', 'ACTIVE', 'ARCHIVED'] },
    },
  },
  'POST /api/v1/retention-runs/dry-run': {
    type: 'object',
    required: ['policyId', 'asOf'],
    properties: {
      policyId: { type: 'string', format: 'uuid' },
      asOf: { type: 'string', format: 'date-time' },
    },
  },
  'POST /api/v1/legal-holds': {
    type: 'object',
    required: ['entityType', 'entityId', 'reason'],
    properties: {
      entityType: { type: 'string' },
      entityId: { type: 'string', format: 'uuid' },
      reason: { type: 'string' },
    },
  },
  'POST /api/v1/legal-holds/{id}/release': {
    type: 'object',
    required: ['version', 'reason'],
    properties: {
      version: { type: 'integer', minimum: 1 },
      reason: { type: 'string', minLength: 1, maxLength: 2000 },
    },
  },
  'POST /public/v1/job-postings/{publicId}/application-upload-sessions': {
    type: 'object',
    required: ['applicationFormVersionId', 'questionVersionId'],
    properties: {
      applicationFormVersionId: { type: 'string', format: 'uuid' },
      questionVersionId: { type: 'string', format: 'uuid' },
    },
  },
  'POST /public/v1/job-postings/{publicId}/applications': {
    type: 'object',
    required: [
      'applicationFormVersionId',
      'name',
      'primaryEmail',
      'country',
      'phone',
      'purpose',
      'jurisdiction',
      'privacyNoticeVersionId',
      'consentEvidence',
      'answers',
    ],
    properties: {
      applicationFormVersionId: { type: 'string', format: 'uuid' },
      name: { type: 'string' },
      primaryEmail: { type: 'string', format: 'email', maxLength: 320 },
      country: { type: 'string' },
      phone: { type: ['string', 'null'] },
      purpose: { type: 'string' },
      jurisdiction: { type: 'string' },
      privacyNoticeVersionId: { type: 'string', format: 'uuid' },
      consentEvidence: {
        type: 'object',
        required: ['accepted'],
        additionalProperties: false,
        properties: { accepted: { type: 'boolean', const: true } },
        nullable: true,
      },
      answers: {
        type: 'array',
        items: {
          type: 'object',
          required: ['questionId', 'type', 'value'],
          properties: {
            questionId: { type: 'string', format: 'uuid' },
            type: { type: 'string', enum: ['SHORT_TEXT', 'LONG_TEXT'] },
            value: { type: 'string' },
          },
          variants: [
            {
              type: 'object',
              required: ['questionId', 'type', 'value'],
              properties: {
                questionId: { type: 'string', format: 'uuid' },
                type: { type: 'string', enum: ['SHORT_TEXT', 'LONG_TEXT'] },
                value: { type: 'string' },
              },
            },
            {
              type: 'object',
              required: ['questionId', 'type', 'values'],
              properties: {
                questionId: { type: 'string', format: 'uuid' },
                type: { type: 'string', enum: ['SINGLE_CHOICE', 'MULTI_CHOICE'] },
                values: { type: 'array', items: { type: 'string' } },
              },
            },
            {
              type: 'object',
              required: ['questionId', 'type', 'value'],
              properties: {
                questionId: { type: 'string', format: 'uuid' },
                type: { type: 'string', enum: ['DATE'] },
                value: { type: 'string', format: 'date', pattern: '^\\d{4}-\\d{2}-\\d{2}$' },
              },
            },
            {
              type: 'object',
              required: ['questionId', 'type', 'value'],
              properties: {
                questionId: { type: 'string', format: 'uuid' },
                type: { type: 'string', enum: ['BOOLEAN'] },
                value: { type: 'boolean' },
              },
            },
            {
              type: 'object',
              required: ['questionId', 'type', 'fileIds'],
              properties: {
                questionId: { type: 'string', format: 'uuid' },
                type: { type: 'string', enum: ['FILE'] },
                fileIds: { type: 'array', minItems: 1, items: { type: 'string', format: 'uuid' } },
              },
            },
          ],
          discriminator: 'type',
          nullable: false,
        },
      },
    },
  },
  'POST /public/v1/application-files': {},
  'POST /public/v1/offer-access-sessions': {
    type: 'object',
    required: ['token'],
    properties: { token: { type: 'string', minLength: 32, maxLength: 2048 } },
  },
  'POST /public/v1/offers/current/view': {
    type: 'object',
    required: ['viewedAt'],
    properties: { viewedAt: { type: 'string', format: 'date-time' } },
  },
  'POST /public/v1/offers/current/decision': {
    type: 'object',
    required: ['decision', 'reason'],
    properties: {
      decision: { type: 'string', enum: ['ACCEPTED', 'DECLINED'] },
      reason: { type: ['string', 'null'], maxLength: 2000 },
    },
  },
  'POST /public/v1/privacy-requests/consent-withdrawal-links': {
    type: 'object',
    required: ['email', 'purpose', 'workspaceSlug'],
    properties: {
      email: { type: 'string', format: 'email', maxLength: 320 },
      purpose: { type: 'string', minLength: 1, maxLength: 200 },
      workspaceSlug: { type: 'string', minLength: 1, maxLength: 100 },
    },
  },
  'POST /public/v1/consent-withdrawal-sessions': {
    type: 'object',
    required: ['token'],
    properties: { token: { type: 'string', minLength: 32, maxLength: 2048 } },
  },
  'POST /public/v1/consents/current/withdraw': {
    type: 'object',
    required: ['reason'],
    properties: { reason: { type: ['string', 'null'], maxLength: 2000 } },
  },
  'POST /api/v1/skills': {
    type: 'object',
    required: ['organizationId', 'code', 'name'],
    additionalProperties: false,
    properties: {
      organizationId: {
        type: 'string',
        format: 'uuid',
        pattern:
          '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
      },
      code: { type: 'string', minLength: 1, maxLength: 100, pattern: '^[a-zA-Z0-9_-]+$' },
      name: {
        type: 'string',
        minLength: 1,
        maxLength: 200,
        pattern: '^(?![\\s\\S]*<\\/?[A-Za-z][^>]*>)[\\s\\S]*$',
      },
      ownerEmployeeId: {
        type: 'string',
        format: 'uuid',
        pattern:
          '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
        nullable: true,
      },
    },
  },
  'PATCH /api/v1/skills/{id}': {
    type: 'object',
    required: ['version'],
    additionalProperties: false,
    properties: {
      version: { type: 'integer', maximum: 9007199254740991 },
      name: {
        type: 'string',
        minLength: 1,
        maxLength: 200,
        pattern: '^(?![\\s\\S]*<\\/?[A-Za-z][^>]*>)[\\s\\S]*$',
      },
      ownerEmployeeId: {
        type: 'string',
        format: 'uuid',
        pattern:
          '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
        nullable: true,
      },
    },
  },
  'POST /api/v1/skills/{id}/archive': {
    type: 'object',
    required: ['version', 'reason'],
    additionalProperties: false,
    properties: {
      version: { type: 'integer', maximum: 9007199254740991 },
      reason: {
        type: 'string',
        minLength: 1,
        maxLength: 2000,
        pattern: '^(?![\\s\\S]*<\\/?[A-Za-z][^>]*>)[\\s\\S]*$',
      },
    },
  },
  'POST /api/v1/skills/{id}/versions': {
    type: 'object',
    required: ['version'],
    additionalProperties: false,
    properties: {
      version: { type: 'integer', maximum: 9007199254740991 },
      copyFromVersionId: {
        type: 'string',
        format: 'uuid',
        pattern:
          '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
      },
      content: {
        type: 'object',
        required: ['schemaVersion', 'description', 'category', 'levels', 'resources'],
        additionalProperties: false,
        properties: {
          schemaVersion: { type: 'number', const: 1 },
          description: {
            type: 'string',
            maxLength: 10000,
            pattern: '^(?![\\s\\S]*<\\/?[A-Za-z][^>]*>)[\\s\\S]*$',
          },
          category: {
            type: 'string',
            minLength: 1,
            maxLength: 200,
            pattern: '^(?![\\s\\S]*<\\/?[A-Za-z][^>]*>)[\\s\\S]*$',
          },
          levels: {
            type: 'array',
            maxItems: 5,
            items: {
              type: 'object',
              required: ['level', 'indicators'],
              additionalProperties: false,
              properties: {
                level: {
                  type: 'string',
                  enum: ['POOR', 'BASIC', 'INTERMEDIATE', 'ADVANCED', 'EXPERT'],
                },
                indicators: {
                  type: 'array',
                  maxItems: 20,
                  items: {
                    type: 'string',
                    maxLength: 10000,
                    pattern: '^(?![\\s\\S]*<\\/?[A-Za-z][^>]*>)[\\s\\S]*$',
                  },
                },
              },
            },
          },
          resources: {
            type: 'array',
            maxItems: 20,
            items: { type: 'string', format: 'uri', maxLength: 2000 },
          },
        },
      },
    },
  },
  'PATCH /api/v1/skill-versions/{id}': {
    type: 'object',
    required: ['version', 'content'],
    additionalProperties: false,
    properties: {
      version: { type: 'integer', maximum: 9007199254740991 },
      content: {
        type: 'object',
        required: ['schemaVersion', 'description', 'category', 'levels', 'resources'],
        additionalProperties: false,
        properties: {
          schemaVersion: { type: 'number', const: 1 },
          description: {
            type: 'string',
            maxLength: 10000,
            pattern: '^(?![\\s\\S]*<\\/?[A-Za-z][^>]*>)[\\s\\S]*$',
          },
          category: {
            type: 'string',
            minLength: 1,
            maxLength: 200,
            pattern: '^(?![\\s\\S]*<\\/?[A-Za-z][^>]*>)[\\s\\S]*$',
          },
          levels: {
            type: 'array',
            maxItems: 5,
            items: {
              type: 'object',
              required: ['level', 'indicators'],
              additionalProperties: false,
              properties: {
                level: {
                  type: 'string',
                  enum: ['POOR', 'BASIC', 'INTERMEDIATE', 'ADVANCED', 'EXPERT'],
                },
                indicators: {
                  type: 'array',
                  maxItems: 20,
                  items: {
                    type: 'string',
                    maxLength: 10000,
                    pattern: '^(?![\\s\\S]*<\\/?[A-Za-z][^>]*>)[\\s\\S]*$',
                  },
                },
              },
            },
          },
          resources: {
            type: 'array',
            maxItems: 20,
            items: { type: 'string', format: 'uri', maxLength: 2000 },
          },
        },
      },
    },
  },
  'POST /api/v1/skill-versions/{id}/publish': {
    type: 'object',
    required: ['version'],
    additionalProperties: false,
    properties: { version: { type: 'integer', maximum: 9007199254740991 } },
  },
  'POST /api/v1/skill-versions/{id}/retire': {
    type: 'object',
    required: ['version', 'reason'],
    additionalProperties: false,
    properties: {
      version: { type: 'integer', maximum: 9007199254740991 },
      reason: {
        type: 'string',
        minLength: 1,
        maxLength: 2000,
        pattern: '^(?![\\s\\S]*<\\/?[A-Za-z][^>]*>)[\\s\\S]*$',
      },
    },
  },
  'POST /api/v1/role-profiles': {
    type: 'object',
    required: ['organizationId', 'code', 'name'],
    additionalProperties: false,
    properties: {
      organizationId: {
        type: 'string',
        format: 'uuid',
        pattern:
          '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
      },
      code: { type: 'string', minLength: 1, maxLength: 100, pattern: '^[a-zA-Z0-9_-]+$' },
      name: {
        type: 'string',
        minLength: 1,
        maxLength: 200,
        pattern: '^(?![\\s\\S]*<\\/?[A-Za-z][^>]*>)[\\s\\S]*$',
      },
      ownerEmployeeId: {
        type: 'string',
        format: 'uuid',
        pattern:
          '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
        nullable: true,
      },
      specialisationId: {
        type: 'string',
        format: 'uuid',
        pattern:
          '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
        nullable: true,
      },
      positionId: {
        type: 'string',
        format: 'uuid',
        pattern:
          '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
        nullable: true,
      },
    },
  },
  'PATCH /api/v1/role-profiles/{id}': {
    type: 'object',
    required: ['version'],
    additionalProperties: false,
    properties: {
      version: { type: 'integer', maximum: 9007199254740991 },
      name: {
        type: 'string',
        minLength: 1,
        maxLength: 200,
        pattern: '^(?![\\s\\S]*<\\/?[A-Za-z][^>]*>)[\\s\\S]*$',
      },
      ownerEmployeeId: {
        type: 'string',
        format: 'uuid',
        pattern:
          '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
        nullable: true,
      },
    },
  },
  'POST /api/v1/role-profiles/{id}/archive': {
    type: 'object',
    required: ['version', 'reason'],
    additionalProperties: false,
    properties: {
      version: { type: 'integer', maximum: 9007199254740991 },
      reason: {
        type: 'string',
        minLength: 1,
        maxLength: 2000,
        pattern: '^(?![\\s\\S]*<\\/?[A-Za-z][^>]*>)[\\s\\S]*$',
      },
    },
  },
  'POST /api/v1/role-profiles/{id}/versions': {
    type: 'object',
    required: ['version'],
    additionalProperties: false,
    properties: {
      version: { type: 'integer', maximum: 9007199254740991 },
      copyFromVersionId: {
        type: 'string',
        format: 'uuid',
        pattern:
          '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
      },
      content: {
        type: 'object',
        required: [
          'schemaVersion',
          'mission',
          'seniorityIds',
          'evaluationTemplateVersionId',
          'tasks',
          'skillExpectations',
        ],
        additionalProperties: false,
        properties: {
          schemaVersion: { type: 'number', const: 1 },
          mission: {
            type: 'string',
            maxLength: 10000,
            pattern: '^(?![\\s\\S]*<\\/?[A-Za-z][^>]*>)[\\s\\S]*$',
          },
          seniorityIds: {
            type: 'array',
            maxItems: 20,
            items: {
              type: 'string',
              format: 'uuid',
              pattern:
                '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
            },
          },
          evaluationTemplateVersionId: {
            type: 'string',
            format: 'uuid',
            pattern:
              '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
            nullable: true,
          },
          tasks: {
            type: 'array',
            maxItems: 100,
            items: {
              type: 'object',
              required: [
                'taskKey',
                'title',
                'description',
                'expectedResult',
                'acceptanceCriteria',
                'isRequired',
                'evidenceRequired',
                'dueOffsetDays',
                'levels',
              ],
              additionalProperties: false,
              properties: {
                taskKey: {
                  type: 'string',
                  minLength: 1,
                  maxLength: 100,
                  pattern: '^[a-zA-Z0-9_-]+$',
                },
                title: {
                  type: 'string',
                  minLength: 1,
                  maxLength: 200,
                  pattern: '^(?![\\s\\S]*<\\/?[A-Za-z][^>]*>)[\\s\\S]*$',
                },
                description: {
                  type: 'string',
                  maxLength: 10000,
                  pattern: '^(?![\\s\\S]*<\\/?[A-Za-z][^>]*>)[\\s\\S]*$',
                },
                expectedResult: {
                  type: 'string',
                  maxLength: 10000,
                  pattern: '^(?![\\s\\S]*<\\/?[A-Za-z][^>]*>)[\\s\\S]*$',
                },
                acceptanceCriteria: {
                  type: 'string',
                  maxLength: 10000,
                  pattern: '^(?![\\s\\S]*<\\/?[A-Za-z][^>]*>)[\\s\\S]*$',
                },
                isRequired: { type: 'boolean' },
                evidenceRequired: { type: 'boolean' },
                dueOffsetDays: { type: 'integer', minimum: 0, maximum: 3660, nullable: true },
                levels: {
                  type: 'array',
                  maxItems: 20,
                  items: {
                    type: 'object',
                    required: ['seniorityId', 'weight', 'expectedResult', 'criteria'],
                    additionalProperties: false,
                    properties: {
                      seniorityId: {
                        type: 'string',
                        format: 'uuid',
                        pattern:
                          '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
                      },
                      weight: { type: 'integer', minimum: 0, maximum: 10000 },
                      expectedResult: {
                        type: 'string',
                        maxLength: 10000,
                        pattern: '^(?![\\s\\S]*<\\/?[A-Za-z][^>]*>)[\\s\\S]*$',
                      },
                      criteria: {
                        type: 'array',
                        maxItems: 3,
                        items: {
                          type: 'object',
                          required: ['key', 'title', 'description', 'weight', 'required'],
                          additionalProperties: false,
                          properties: {
                            key: {
                              type: 'string',
                              minLength: 1,
                              maxLength: 100,
                              pattern: '^[a-zA-Z0-9_-]+$',
                            },
                            title: {
                              type: 'string',
                              minLength: 1,
                              maxLength: 200,
                              pattern: '^(?![\\s\\S]*<\\/?[A-Za-z][^>]*>)[\\s\\S]*$',
                            },
                            description: {
                              type: 'string',
                              maxLength: 10000,
                              pattern: '^(?![\\s\\S]*<\\/?[A-Za-z][^>]*>)[\\s\\S]*$',
                            },
                            weight: { type: 'integer', minimum: 0, maximum: 10000 },
                            required: { type: 'boolean' },
                            employeeVisible: { type: 'boolean' },
                          },
                        },
                      },
                    },
                  },
                },
              },
            },
          },
          skillExpectations: {
            type: 'array',
            maxItems: 2000,
            items: {
              type: 'object',
              required: ['skillVersionId', 'seniorityId', 'expectedLevel', 'weight', 'required'],
              additionalProperties: false,
              properties: {
                skillVersionId: {
                  type: 'string',
                  format: 'uuid',
                  pattern:
                    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
                },
                seniorityId: {
                  type: 'string',
                  format: 'uuid',
                  pattern:
                    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
                },
                expectedLevel: {
                  type: 'string',
                  enum: ['POOR', 'BASIC', 'INTERMEDIATE', 'ADVANCED', 'EXPERT'],
                },
                weight: { type: 'integer', minimum: 0, maximum: 10000 },
                required: { type: 'boolean' },
              },
            },
          },
        },
      },
    },
  },
  'PATCH /api/v1/role-profile-versions/{id}': {
    type: 'object',
    required: ['version', 'content'],
    additionalProperties: false,
    properties: {
      version: { type: 'integer', maximum: 9007199254740991 },
      content: {
        type: 'object',
        required: [
          'schemaVersion',
          'mission',
          'seniorityIds',
          'evaluationTemplateVersionId',
          'tasks',
          'skillExpectations',
        ],
        additionalProperties: false,
        properties: {
          schemaVersion: { type: 'number', const: 1 },
          mission: {
            type: 'string',
            maxLength: 10000,
            pattern: '^(?![\\s\\S]*<\\/?[A-Za-z][^>]*>)[\\s\\S]*$',
          },
          seniorityIds: {
            type: 'array',
            maxItems: 20,
            items: {
              type: 'string',
              format: 'uuid',
              pattern:
                '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
            },
          },
          evaluationTemplateVersionId: {
            type: 'string',
            format: 'uuid',
            pattern:
              '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
            nullable: true,
          },
          tasks: {
            type: 'array',
            maxItems: 100,
            items: {
              type: 'object',
              required: [
                'taskKey',
                'title',
                'description',
                'expectedResult',
                'acceptanceCriteria',
                'isRequired',
                'evidenceRequired',
                'dueOffsetDays',
                'levels',
              ],
              additionalProperties: false,
              properties: {
                taskKey: {
                  type: 'string',
                  minLength: 1,
                  maxLength: 100,
                  pattern: '^[a-zA-Z0-9_-]+$',
                },
                title: {
                  type: 'string',
                  minLength: 1,
                  maxLength: 200,
                  pattern: '^(?![\\s\\S]*<\\/?[A-Za-z][^>]*>)[\\s\\S]*$',
                },
                description: {
                  type: 'string',
                  maxLength: 10000,
                  pattern: '^(?![\\s\\S]*<\\/?[A-Za-z][^>]*>)[\\s\\S]*$',
                },
                expectedResult: {
                  type: 'string',
                  maxLength: 10000,
                  pattern: '^(?![\\s\\S]*<\\/?[A-Za-z][^>]*>)[\\s\\S]*$',
                },
                acceptanceCriteria: {
                  type: 'string',
                  maxLength: 10000,
                  pattern: '^(?![\\s\\S]*<\\/?[A-Za-z][^>]*>)[\\s\\S]*$',
                },
                isRequired: { type: 'boolean' },
                evidenceRequired: { type: 'boolean' },
                dueOffsetDays: { type: 'integer', minimum: 0, maximum: 3660, nullable: true },
                levels: {
                  type: 'array',
                  maxItems: 20,
                  items: {
                    type: 'object',
                    required: ['seniorityId', 'weight', 'expectedResult', 'criteria'],
                    additionalProperties: false,
                    properties: {
                      seniorityId: {
                        type: 'string',
                        format: 'uuid',
                        pattern:
                          '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
                      },
                      weight: { type: 'integer', minimum: 0, maximum: 10000 },
                      expectedResult: {
                        type: 'string',
                        maxLength: 10000,
                        pattern: '^(?![\\s\\S]*<\\/?[A-Za-z][^>]*>)[\\s\\S]*$',
                      },
                      criteria: {
                        type: 'array',
                        maxItems: 3,
                        items: {
                          type: 'object',
                          required: ['key', 'title', 'description', 'weight', 'required'],
                          additionalProperties: false,
                          properties: {
                            key: {
                              type: 'string',
                              minLength: 1,
                              maxLength: 100,
                              pattern: '^[a-zA-Z0-9_-]+$',
                            },
                            title: {
                              type: 'string',
                              minLength: 1,
                              maxLength: 200,
                              pattern: '^(?![\\s\\S]*<\\/?[A-Za-z][^>]*>)[\\s\\S]*$',
                            },
                            description: {
                              type: 'string',
                              maxLength: 10000,
                              pattern: '^(?![\\s\\S]*<\\/?[A-Za-z][^>]*>)[\\s\\S]*$',
                            },
                            weight: { type: 'integer', minimum: 0, maximum: 10000 },
                            required: { type: 'boolean' },
                            employeeVisible: { type: 'boolean' },
                          },
                        },
                      },
                    },
                  },
                },
              },
            },
          },
          skillExpectations: {
            type: 'array',
            maxItems: 2000,
            items: {
              type: 'object',
              required: ['skillVersionId', 'seniorityId', 'expectedLevel', 'weight', 'required'],
              additionalProperties: false,
              properties: {
                skillVersionId: {
                  type: 'string',
                  format: 'uuid',
                  pattern:
                    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
                },
                seniorityId: {
                  type: 'string',
                  format: 'uuid',
                  pattern:
                    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
                },
                expectedLevel: {
                  type: 'string',
                  enum: ['POOR', 'BASIC', 'INTERMEDIATE', 'ADVANCED', 'EXPERT'],
                },
                weight: { type: 'integer', minimum: 0, maximum: 10000 },
                required: { type: 'boolean' },
              },
            },
          },
        },
      },
    },
  },
  'POST /api/v1/role-profile-versions/{id}/publish': {
    type: 'object',
    required: ['version'],
    additionalProperties: false,
    properties: { version: { type: 'integer', maximum: 9007199254740991 } },
  },
  'POST /api/v1/role-profile-versions/{id}/retire': {
    type: 'object',
    required: ['version', 'reason'],
    additionalProperties: false,
    properties: {
      version: { type: 'integer', maximum: 9007199254740991 },
      reason: {
        type: 'string',
        minLength: 1,
        maxLength: 2000,
        pattern: '^(?![\\s\\S]*<\\/?[A-Za-z][^>]*>)[\\s\\S]*$',
      },
    },
  },
  'POST /api/v1/employee-evaluation-templates': {
    type: 'object',
    required: ['organizationId', 'code', 'name'],
    additionalProperties: false,
    properties: {
      organizationId: {
        type: 'string',
        format: 'uuid',
        pattern:
          '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
      },
      code: { type: 'string', minLength: 1, maxLength: 100, pattern: '^[a-zA-Z0-9_-]+$' },
      name: {
        type: 'string',
        minLength: 1,
        maxLength: 200,
        pattern: '^(?![\\s\\S]*<\\/?[A-Za-z][^>]*>)[\\s\\S]*$',
      },
      ownerEmployeeId: {
        type: 'string',
        format: 'uuid',
        pattern:
          '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
        nullable: true,
      },
    },
  },
  'PATCH /api/v1/employee-evaluation-templates/{id}': {
    type: 'object',
    required: ['version'],
    additionalProperties: false,
    properties: {
      version: { type: 'integer', maximum: 9007199254740991 },
      name: {
        type: 'string',
        minLength: 1,
        maxLength: 200,
        pattern: '^(?![\\s\\S]*<\\/?[A-Za-z][^>]*>)[\\s\\S]*$',
      },
      ownerEmployeeId: {
        type: 'string',
        format: 'uuid',
        pattern:
          '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
        nullable: true,
      },
    },
  },
  'POST /api/v1/employee-evaluation-templates/{id}/archive': {
    type: 'object',
    required: ['version', 'reason'],
    additionalProperties: false,
    properties: {
      version: { type: 'integer', maximum: 9007199254740991 },
      reason: {
        type: 'string',
        minLength: 1,
        maxLength: 2000,
        pattern: '^(?![\\s\\S]*<\\/?[A-Za-z][^>]*>)[\\s\\S]*$',
      },
    },
  },
  'POST /api/v1/employee-evaluation-templates/{id}/versions': {
    type: 'object',
    required: ['version'],
    additionalProperties: false,
    properties: {
      version: { type: 'integer', maximum: 9007199254740991 },
      copyFromVersionId: {
        type: 'string',
        format: 'uuid',
        pattern:
          '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
      },
      content: {
        type: 'object',
        required: [
          'schemaVersion',
          'selfReviewRequired',
          'sectionWeights',
          'grades',
          'masteryMapping',
          'values',
          'questionGroups',
          'feedbackEmployeeVisible',
        ],
        additionalProperties: false,
        properties: {
          schemaVersion: { type: 'number', const: 1 },
          selfReviewRequired: { type: 'boolean' },
          sectionWeights: {
            type: 'object',
            required: ['DELIVERABLES', 'SKILLS', 'VALUES'],
            additionalProperties: false,
            properties: {
              DELIVERABLES: { type: 'integer', minimum: 0, maximum: 10000 },
              SKILLS: { type: 'integer', minimum: 0, maximum: 10000 },
              VALUES: { type: 'integer', minimum: 0, maximum: 10000 },
            },
          },
          grades: {
            type: 'array',
            maxItems: 5,
            items: {
              type: 'object',
              required: ['grade', 'title', 'description'],
              additionalProperties: false,
              properties: {
                grade: { type: 'integer', minimum: 1, maximum: 5 },
                title: {
                  type: 'string',
                  minLength: 1,
                  maxLength: 200,
                  pattern: '^(?![\\s\\S]*<\\/?[A-Za-z][^>]*>)[\\s\\S]*$',
                },
                description: {
                  type: 'string',
                  maxLength: 10000,
                  pattern: '^(?![\\s\\S]*<\\/?[A-Za-z][^>]*>)[\\s\\S]*$',
                },
              },
            },
          },
          masteryMapping: {
            type: 'array',
            maxItems: 25,
            items: {
              type: 'object',
              required: ['expected', 'actual', 'grade'],
              additionalProperties: false,
              properties: {
                expected: {
                  type: 'string',
                  enum: ['POOR', 'BASIC', 'INTERMEDIATE', 'ADVANCED', 'EXPERT'],
                },
                actual: {
                  type: 'string',
                  enum: ['POOR', 'BASIC', 'INTERMEDIATE', 'ADVANCED', 'EXPERT'],
                },
                grade: { type: 'integer', minimum: 1, maximum: 5 },
              },
            },
          },
          values: {
            type: 'array',
            maxItems: 100,
            items: {
              type: 'object',
              required: ['key', 'title', 'description', 'weight', 'required'],
              additionalProperties: false,
              properties: {
                key: { type: 'string', minLength: 1, maxLength: 100, pattern: '^[a-zA-Z0-9_-]+$' },
                title: {
                  type: 'string',
                  minLength: 1,
                  maxLength: 200,
                  pattern: '^(?![\\s\\S]*<\\/?[A-Za-z][^>]*>)[\\s\\S]*$',
                },
                description: {
                  type: 'string',
                  maxLength: 10000,
                  pattern: '^(?![\\s\\S]*<\\/?[A-Za-z][^>]*>)[\\s\\S]*$',
                },
                weight: { type: 'integer', minimum: 0, maximum: 10000 },
                required: { type: 'boolean' },
                employeeVisible: { type: 'boolean' },
              },
            },
          },
          questionGroups: {
            type: 'array',
            maxItems: 20,
            items: {
              type: 'object',
              required: ['key', 'title', 'description', 'reviewerTypes', 'questions'],
              additionalProperties: false,
              properties: {
                key: { type: 'string', minLength: 1, maxLength: 100, pattern: '^[a-zA-Z0-9_-]+$' },
                title: {
                  type: 'string',
                  minLength: 1,
                  maxLength: 200,
                  pattern: '^(?![\\s\\S]*<\\/?[A-Za-z][^>]*>)[\\s\\S]*$',
                },
                description: {
                  type: 'string',
                  maxLength: 10000,
                  pattern: '^(?![\\s\\S]*<\\/?[A-Za-z][^>]*>)[\\s\\S]*$',
                },
                reviewerTypes: {
                  type: 'array',
                  minItems: 1,
                  maxItems: 2,
                  items: { type: 'string', enum: ['SELF', 'LINE_MANAGER'] },
                },
                questions: {
                  type: 'array',
                  maxItems: 100,
                  items: {
                    type: 'object',
                    required: [
                      'key',
                      'title',
                      'description',
                      'type',
                      'required',
                      'employeeVisible',
                      'options',
                    ],
                    additionalProperties: false,
                    properties: {
                      key: {
                        type: 'string',
                        minLength: 1,
                        maxLength: 100,
                        pattern: '^[a-zA-Z0-9_-]+$',
                      },
                      title: {
                        type: 'string',
                        minLength: 1,
                        maxLength: 200,
                        pattern: '^(?![\\s\\S]*<\\/?[A-Za-z][^>]*>)[\\s\\S]*$',
                      },
                      description: {
                        type: 'string',
                        maxLength: 10000,
                        pattern: '^(?![\\s\\S]*<\\/?[A-Za-z][^>]*>)[\\s\\S]*$',
                      },
                      type: { type: 'string', enum: ['TEXT', 'CHOICE', 'SCALE'] },
                      required: { type: 'boolean' },
                      employeeVisible: { type: 'boolean' },
                      options: {
                        type: 'array',
                        maxItems: 20,
                        items: {
                          type: 'string',
                          minLength: 1,
                          maxLength: 200,
                          pattern: '^(?![\\s\\S]*<\\/?[A-Za-z][^>]*>)[\\s\\S]*$',
                        },
                      },
                    },
                  },
                },
              },
            },
          },
          feedbackEmployeeVisible: { type: 'boolean' },
        },
      },
    },
  },
  'PATCH /api/v1/employee-evaluation-template-versions/{id}': {
    type: 'object',
    required: ['version', 'content'],
    additionalProperties: false,
    properties: {
      version: { type: 'integer', maximum: 9007199254740991 },
      content: {
        type: 'object',
        required: [
          'schemaVersion',
          'selfReviewRequired',
          'sectionWeights',
          'grades',
          'masteryMapping',
          'values',
          'questionGroups',
          'feedbackEmployeeVisible',
        ],
        additionalProperties: false,
        properties: {
          schemaVersion: { type: 'number', const: 1 },
          selfReviewRequired: { type: 'boolean' },
          sectionWeights: {
            type: 'object',
            required: ['DELIVERABLES', 'SKILLS', 'VALUES'],
            additionalProperties: false,
            properties: {
              DELIVERABLES: { type: 'integer', minimum: 0, maximum: 10000 },
              SKILLS: { type: 'integer', minimum: 0, maximum: 10000 },
              VALUES: { type: 'integer', minimum: 0, maximum: 10000 },
            },
          },
          grades: {
            type: 'array',
            maxItems: 5,
            items: {
              type: 'object',
              required: ['grade', 'title', 'description'],
              additionalProperties: false,
              properties: {
                grade: { type: 'integer', minimum: 1, maximum: 5 },
                title: {
                  type: 'string',
                  minLength: 1,
                  maxLength: 200,
                  pattern: '^(?![\\s\\S]*<\\/?[A-Za-z][^>]*>)[\\s\\S]*$',
                },
                description: {
                  type: 'string',
                  maxLength: 10000,
                  pattern: '^(?![\\s\\S]*<\\/?[A-Za-z][^>]*>)[\\s\\S]*$',
                },
              },
            },
          },
          masteryMapping: {
            type: 'array',
            maxItems: 25,
            items: {
              type: 'object',
              required: ['expected', 'actual', 'grade'],
              additionalProperties: false,
              properties: {
                expected: {
                  type: 'string',
                  enum: ['POOR', 'BASIC', 'INTERMEDIATE', 'ADVANCED', 'EXPERT'],
                },
                actual: {
                  type: 'string',
                  enum: ['POOR', 'BASIC', 'INTERMEDIATE', 'ADVANCED', 'EXPERT'],
                },
                grade: { type: 'integer', minimum: 1, maximum: 5 },
              },
            },
          },
          values: {
            type: 'array',
            maxItems: 100,
            items: {
              type: 'object',
              required: ['key', 'title', 'description', 'weight', 'required'],
              additionalProperties: false,
              properties: {
                key: { type: 'string', minLength: 1, maxLength: 100, pattern: '^[a-zA-Z0-9_-]+$' },
                title: {
                  type: 'string',
                  minLength: 1,
                  maxLength: 200,
                  pattern: '^(?![\\s\\S]*<\\/?[A-Za-z][^>]*>)[\\s\\S]*$',
                },
                description: {
                  type: 'string',
                  maxLength: 10000,
                  pattern: '^(?![\\s\\S]*<\\/?[A-Za-z][^>]*>)[\\s\\S]*$',
                },
                weight: { type: 'integer', minimum: 0, maximum: 10000 },
                required: { type: 'boolean' },
                employeeVisible: { type: 'boolean' },
              },
            },
          },
          questionGroups: {
            type: 'array',
            maxItems: 20,
            items: {
              type: 'object',
              required: ['key', 'title', 'description', 'reviewerTypes', 'questions'],
              additionalProperties: false,
              properties: {
                key: { type: 'string', minLength: 1, maxLength: 100, pattern: '^[a-zA-Z0-9_-]+$' },
                title: {
                  type: 'string',
                  minLength: 1,
                  maxLength: 200,
                  pattern: '^(?![\\s\\S]*<\\/?[A-Za-z][^>]*>)[\\s\\S]*$',
                },
                description: {
                  type: 'string',
                  maxLength: 10000,
                  pattern: '^(?![\\s\\S]*<\\/?[A-Za-z][^>]*>)[\\s\\S]*$',
                },
                reviewerTypes: {
                  type: 'array',
                  minItems: 1,
                  maxItems: 2,
                  items: { type: 'string', enum: ['SELF', 'LINE_MANAGER'] },
                },
                questions: {
                  type: 'array',
                  maxItems: 100,
                  items: {
                    type: 'object',
                    required: [
                      'key',
                      'title',
                      'description',
                      'type',
                      'required',
                      'employeeVisible',
                      'options',
                    ],
                    additionalProperties: false,
                    properties: {
                      key: {
                        type: 'string',
                        minLength: 1,
                        maxLength: 100,
                        pattern: '^[a-zA-Z0-9_-]+$',
                      },
                      title: {
                        type: 'string',
                        minLength: 1,
                        maxLength: 200,
                        pattern: '^(?![\\s\\S]*<\\/?[A-Za-z][^>]*>)[\\s\\S]*$',
                      },
                      description: {
                        type: 'string',
                        maxLength: 10000,
                        pattern: '^(?![\\s\\S]*<\\/?[A-Za-z][^>]*>)[\\s\\S]*$',
                      },
                      type: { type: 'string', enum: ['TEXT', 'CHOICE', 'SCALE'] },
                      required: { type: 'boolean' },
                      employeeVisible: { type: 'boolean' },
                      options: {
                        type: 'array',
                        maxItems: 20,
                        items: {
                          type: 'string',
                          minLength: 1,
                          maxLength: 200,
                          pattern: '^(?![\\s\\S]*<\\/?[A-Za-z][^>]*>)[\\s\\S]*$',
                        },
                      },
                    },
                  },
                },
              },
            },
          },
          feedbackEmployeeVisible: { type: 'boolean' },
        },
      },
    },
  },
  'POST /api/v1/employee-evaluation-template-versions/{id}/publish': {
    type: 'object',
    required: ['version'],
    additionalProperties: false,
    properties: { version: { type: 'integer', maximum: 9007199254740991 } },
  },
  'POST /api/v1/employee-evaluation-template-versions/{id}/retire': {
    type: 'object',
    required: ['version', 'reason'],
    additionalProperties: false,
    properties: {
      version: { type: 'integer', maximum: 9007199254740991 },
      reason: {
        type: 'string',
        minLength: 1,
        maxLength: 2000,
        pattern: '^(?![\\s\\S]*<\\/?[A-Za-z][^>]*>)[\\s\\S]*$',
      },
    },
  },
  'PUT /api/v1/specialisations/{id}/allowed-seniorities': {
    type: 'object',
    required: ['version', 'seniorityIds'],
    additionalProperties: false,
    properties: {
      version: { type: 'integer', maximum: 9007199254740991 },
      seniorityIds: {
        type: 'array',
        minItems: 1,
        maxItems: 20,
        items: {
          type: 'string',
          format: 'uuid',
          pattern:
            '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
        },
      },
    },
  },
  'POST /api/v1/employees/{id}/role-profile-assignments': {
    type: 'object',
    required: ['roleProfileVersionId', 'expectedEmployeeVersion', 'reason'],
    additionalProperties: false,
    properties: {
      roleProfileVersionId: {
        type: 'string',
        format: 'uuid',
        pattern:
          '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
      },
      expectedEmployeeVersion: { type: 'integer', maximum: 9007199254740991 },
      reason: {
        type: 'string',
        minLength: 1,
        maxLength: 2000,
        pattern: '^(?![\\s\\S]*<\\/?[A-Za-z][^>]*>)[\\s\\S]*$',
      },
    },
  },
  'POST /api/v1/performance-cycles': {
    type: 'object',
    required: ['organizationId', 'name', 'periodStart', 'periodEnd', 'reviewOpenAt', 'reviewDueAt'],
    additionalProperties: false,
    properties: {
      organizationId: {
        type: 'string',
        format: 'uuid',
        pattern:
          '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
      },
      name: {
        type: 'string',
        minLength: 1,
        maxLength: 200,
        pattern: '^(?![\\s\\S]*<\\/?[A-Za-z][^>]*>)[\\s\\S]*$',
      },
      periodStart: {
        type: 'string',
        format: 'date',
        pattern:
          '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))$',
      },
      periodEnd: {
        type: 'string',
        format: 'date',
        pattern:
          '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))$',
      },
      reviewOpenAt: {
        type: 'string',
        format: 'date-time',
        pattern:
          '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$',
      },
      reviewDueAt: {
        type: 'string',
        format: 'date-time',
        pattern:
          '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$',
      },
    },
  },
  'PATCH /api/v1/performance-cycles/{id}': {
    type: 'object',
    required: ['version'],
    additionalProperties: false,
    properties: {
      name: {
        type: 'string',
        minLength: 1,
        maxLength: 200,
        pattern: '^(?![\\s\\S]*<\\/?[A-Za-z][^>]*>)[\\s\\S]*$',
      },
      periodStart: {
        type: 'string',
        format: 'date',
        pattern:
          '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))$',
      },
      periodEnd: {
        type: 'string',
        format: 'date',
        pattern:
          '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))$',
      },
      reviewOpenAt: {
        type: 'string',
        format: 'date-time',
        pattern:
          '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$',
      },
      reviewDueAt: {
        type: 'string',
        format: 'date-time',
        pattern:
          '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$',
      },
      version: { type: 'integer', maximum: 9007199254740991 },
      reason: {
        type: 'string',
        minLength: 1,
        maxLength: 2000,
        pattern: '^(?![\\s\\S]*<\\/?[A-Za-z][^>]*>)[\\s\\S]*$',
      },
    },
  },
  'POST /api/v1/performance-cycles/{id}/activate': {
    type: 'object',
    required: ['version'],
    additionalProperties: false,
    properties: { version: { type: 'integer', maximum: 9007199254740991 } },
  },
  'POST /api/v1/performance-cycles/{id}/close': {
    type: 'object',
    required: ['version'],
    additionalProperties: false,
    properties: { version: { type: 'integer', maximum: 9007199254740991 } },
  },
  'POST /api/v1/performance-cycles/{id}/cancel': {
    type: 'object',
    required: ['version', 'reason'],
    additionalProperties: false,
    properties: {
      version: { type: 'integer', maximum: 9007199254740991 },
      reason: {
        type: 'string',
        minLength: 1,
        maxLength: 2000,
        pattern: '^(?![\\s\\S]*<\\/?[A-Za-z][^>]*>)[\\s\\S]*$',
      },
    },
  },
  'POST /api/v1/employees/{id}/work-plans': {
    type: 'object',
    required: ['cycleId', 'assignmentId'],
    additionalProperties: false,
    properties: {
      cycleId: {
        type: 'string',
        format: 'uuid',
        pattern:
          '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
      },
      assignmentId: {
        type: 'string',
        format: 'uuid',
        pattern:
          '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
      },
      replacesPlanId: {
        type: 'string',
        format: 'uuid',
        pattern:
          '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
      },
    },
  },
  'PATCH /api/v1/work-plans/{id}': {
    type: 'object',
    required: ['version'],
    additionalProperties: false,
    properties: {
      version: { type: 'integer', maximum: 9007199254740991 },
      title: {
        type: 'string',
        minLength: 1,
        maxLength: 200,
        pattern: '^(?![\\s\\S]*<\\/?[A-Za-z][^>]*>)[\\s\\S]*$',
      },
    },
  },
  'POST /api/v1/work-plans/{id}/activate': {
    type: 'object',
    required: ['version'],
    additionalProperties: false,
    properties: { version: { type: 'integer', maximum: 9007199254740991 } },
  },
  'POST /api/v1/work-plans/{id}/cancel': {
    type: 'object',
    required: ['version', 'reason'],
    additionalProperties: false,
    properties: {
      version: { type: 'integer', maximum: 9007199254740991 },
      reason: {
        type: 'string',
        minLength: 1,
        maxLength: 2000,
        pattern: '^(?![\\s\\S]*<\\/?[A-Za-z][^>]*>)[\\s\\S]*$',
      },
    },
  },
  'POST /api/v1/work-plans/{id}/tasks': {
    type: 'object',
    required: ['version', 'definition', 'dueDate'],
    additionalProperties: false,
    properties: {
      version: { type: 'integer', maximum: 9007199254740991 },
      definition: {
        type: 'object',
        required: [
          'taskKey',
          'title',
          'description',
          'expectedResult',
          'acceptanceCriteria',
          'isRequired',
          'evidenceRequired',
          'dueOffsetDays',
          'criteria',
          'weight',
        ],
        additionalProperties: false,
        properties: {
          taskKey: { type: 'string', minLength: 1, maxLength: 100, pattern: '^[a-zA-Z0-9_-]+$' },
          title: {
            type: 'string',
            minLength: 1,
            maxLength: 200,
            pattern: '^(?![\\s\\S]*<\\/?[A-Za-z][^>]*>)[\\s\\S]*$',
          },
          description: {
            type: 'string',
            maxLength: 10000,
            pattern: '^(?![\\s\\S]*<\\/?[A-Za-z][^>]*>)[\\s\\S]*$',
          },
          expectedResult: {
            type: 'string',
            maxLength: 10000,
            pattern: '^(?![\\s\\S]*<\\/?[A-Za-z][^>]*>)[\\s\\S]*$',
          },
          acceptanceCriteria: {
            type: 'string',
            maxLength: 10000,
            pattern: '^(?![\\s\\S]*<\\/?[A-Za-z][^>]*>)[\\s\\S]*$',
          },
          isRequired: { type: 'boolean' },
          evidenceRequired: { type: 'boolean' },
          dueOffsetDays: { type: 'integer', minimum: 0, maximum: 3660, nullable: true },
          criteria: {
            type: 'array',
            maxItems: 3,
            items: {
              type: 'object',
              required: ['key', 'title', 'description', 'weight', 'required'],
              additionalProperties: false,
              properties: {
                key: { type: 'string', minLength: 1, maxLength: 100, pattern: '^[a-zA-Z0-9_-]+$' },
                title: {
                  type: 'string',
                  minLength: 1,
                  maxLength: 200,
                  pattern: '^(?![\\s\\S]*<\\/?[A-Za-z][^>]*>)[\\s\\S]*$',
                },
                description: {
                  type: 'string',
                  maxLength: 10000,
                  pattern: '^(?![\\s\\S]*<\\/?[A-Za-z][^>]*>)[\\s\\S]*$',
                },
                weight: { type: 'integer', minimum: 0, maximum: 10000 },
                required: { type: 'boolean' },
                employeeVisible: { type: 'boolean' },
              },
            },
          },
          weight: { type: 'integer', minimum: 0, maximum: 10000 },
        },
      },
      dueDate: {
        type: 'string',
        format: 'date',
        pattern:
          '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))$',
      },
    },
  },
  'PATCH /api/v1/work-tasks/{id}': {
    type: 'object',
    required: ['version', 'definition', 'dueDate'],
    additionalProperties: false,
    properties: {
      version: { type: 'integer', maximum: 9007199254740991 },
      definition: {
        type: 'object',
        required: [
          'taskKey',
          'title',
          'description',
          'expectedResult',
          'acceptanceCriteria',
          'isRequired',
          'evidenceRequired',
          'dueOffsetDays',
          'criteria',
          'weight',
        ],
        additionalProperties: false,
        properties: {
          taskKey: { type: 'string', minLength: 1, maxLength: 100, pattern: '^[a-zA-Z0-9_-]+$' },
          title: {
            type: 'string',
            minLength: 1,
            maxLength: 200,
            pattern: '^(?![\\s\\S]*<\\/?[A-Za-z][^>]*>)[\\s\\S]*$',
          },
          description: {
            type: 'string',
            maxLength: 10000,
            pattern: '^(?![\\s\\S]*<\\/?[A-Za-z][^>]*>)[\\s\\S]*$',
          },
          expectedResult: {
            type: 'string',
            maxLength: 10000,
            pattern: '^(?![\\s\\S]*<\\/?[A-Za-z][^>]*>)[\\s\\S]*$',
          },
          acceptanceCriteria: {
            type: 'string',
            maxLength: 10000,
            pattern: '^(?![\\s\\S]*<\\/?[A-Za-z][^>]*>)[\\s\\S]*$',
          },
          isRequired: { type: 'boolean' },
          evidenceRequired: { type: 'boolean' },
          dueOffsetDays: { type: 'integer', minimum: 0, maximum: 3660, nullable: true },
          criteria: {
            type: 'array',
            maxItems: 3,
            items: {
              type: 'object',
              required: ['key', 'title', 'description', 'weight', 'required'],
              additionalProperties: false,
              properties: {
                key: { type: 'string', minLength: 1, maxLength: 100, pattern: '^[a-zA-Z0-9_-]+$' },
                title: {
                  type: 'string',
                  minLength: 1,
                  maxLength: 200,
                  pattern: '^(?![\\s\\S]*<\\/?[A-Za-z][^>]*>)[\\s\\S]*$',
                },
                description: {
                  type: 'string',
                  maxLength: 10000,
                  pattern: '^(?![\\s\\S]*<\\/?[A-Za-z][^>]*>)[\\s\\S]*$',
                },
                weight: { type: 'integer', minimum: 0, maximum: 10000 },
                required: { type: 'boolean' },
                employeeVisible: { type: 'boolean' },
              },
            },
          },
          weight: { type: 'integer', minimum: 0, maximum: 10000 },
        },
      },
      dueDate: {
        type: 'string',
        format: 'date',
        pattern:
          '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))$',
      },
    },
  },
  'PATCH /api/v1/work-tasks/{id}/progress': {
    type: 'object',
    required: ['version', 'result', 'evidence'],
    additionalProperties: false,
    properties: {
      version: { type: 'integer', maximum: 9007199254740991 },
      result: {
        type: 'string',
        maxLength: 10000,
        pattern: '^(?![\\s\\S]*<\\/?[A-Za-z][^>]*>)[\\s\\S]*$',
      },
      evidence: {
        type: 'array',
        maxItems: 20,
        items: { type: 'string', format: 'uri', maxLength: 2000 },
      },
    },
  },
  'POST /api/v1/work-tasks/{id}/start': {
    type: 'object',
    required: ['version'],
    additionalProperties: false,
    properties: { version: { type: 'integer', maximum: 9007199254740991 } },
  },
  'POST /api/v1/work-tasks/{id}/submit': {
    type: 'object',
    required: ['version', 'result', 'evidence'],
    additionalProperties: false,
    properties: {
      version: { type: 'integer', maximum: 9007199254740991 },
      result: {
        type: 'string',
        maxLength: 10000,
        pattern: '^(?![\\s\\S]*<\\/?[A-Za-z][^>]*>)[\\s\\S]*$',
      },
      evidence: {
        type: 'array',
        maxItems: 20,
        items: { type: 'string', format: 'uri', maxLength: 2000 },
      },
    },
  },
  'POST /api/v1/work-tasks/{id}/accept': {
    type: 'object',
    required: ['version'],
    additionalProperties: false,
    properties: { version: { type: 'integer', maximum: 9007199254740991 } },
  },
  'POST /api/v1/work-tasks/{id}/return': {
    type: 'object',
    required: ['version', 'reason'],
    additionalProperties: false,
    properties: {
      version: { type: 'integer', maximum: 9007199254740991 },
      reason: {
        type: 'string',
        minLength: 1,
        maxLength: 2000,
        pattern: '^(?![\\s\\S]*<\\/?[A-Za-z][^>]*>)[\\s\\S]*$',
      },
    },
  },
  'POST /api/v1/work-tasks/{id}/exclude': {
    type: 'object',
    required: ['version', 'reason'],
    additionalProperties: false,
    properties: {
      version: { type: 'integer', maximum: 9007199254740991 },
      reason: {
        type: 'string',
        minLength: 1,
        maxLength: 2000,
        pattern: '^(?![\\s\\S]*<\\/?[A-Za-z][^>]*>)[\\s\\S]*$',
      },
    },
  },
  'POST /api/v1/work-plans/{id}/reviews': {
    type: 'object',
    required: ['version'],
    additionalProperties: false,
    properties: { version: { type: 'integer', maximum: 9007199254740991 } },
  },
  'POST /api/v1/reviews/{id}/open': {
    type: 'object',
    required: ['version'],
    additionalProperties: false,
    properties: { version: { type: 'integer', maximum: 9007199254740991 } },
  },
  'POST /api/v1/reviews/{id}/reviewer': {
    type: 'object',
    required: ['version', 'reason', 'reviewerAccountId', 'submissionVersion'],
    additionalProperties: false,
    properties: {
      version: { type: 'integer', maximum: 9007199254740991 },
      reason: {
        type: 'string',
        minLength: 1,
        maxLength: 2000,
        pattern: '^(?![\\s\\S]*<\\/?[A-Za-z][^>]*>)[\\s\\S]*$',
      },
      reviewerAccountId: {
        type: 'string',
        format: 'uuid',
        pattern:
          '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
      },
      submissionVersion: { type: 'integer', maximum: 9007199254740991 },
    },
  },
  'PATCH /api/v1/reviews/{id}/submissions/{type}': {
    type: 'object',
    required: ['version', 'content'],
    additionalProperties: false,
    properties: {
      version: { type: 'integer', maximum: 9007199254740991 },
      content: {
        type: 'object',
        required: ['answers', 'strengths', 'development'],
        additionalProperties: false,
        properties: {
          answers: {
            type: 'array',
            maxItems: 600,
            items: {
              type: 'object',
              required: ['key', 'value', 'comment'],
              additionalProperties: false,
              properties: {
                key: { type: 'string', minLength: 1, maxLength: 300 },
                value: { type: 'integer', minimum: 1, maximum: 5, nullable: true },
                comment: {
                  type: 'string',
                  maxLength: 10000,
                  pattern: '^(?![\\s\\S]*<\\/?[A-Za-z][^>]*>)[\\s\\S]*$',
                },
              },
            },
          },
          strengths: {
            type: 'string',
            maxLength: 10000,
            pattern: '^(?![\\s\\S]*<\\/?[A-Za-z][^>]*>)[\\s\\S]*$',
          },
          development: {
            type: 'string',
            maxLength: 10000,
            pattern: '^(?![\\s\\S]*<\\/?[A-Za-z][^>]*>)[\\s\\S]*$',
          },
        },
      },
    },
  },
  'POST /api/v1/reviews/{id}/submissions/{type}/submit': {
    type: 'object',
    required: ['version'],
    additionalProperties: false,
    properties: { version: { type: 'integer', maximum: 9007199254740991 } },
  },
  'POST /api/v1/reviews/{id}/submissions/{type}/return': {
    type: 'object',
    required: ['version', 'reason'],
    additionalProperties: false,
    properties: {
      version: { type: 'integer', maximum: 9007199254740991 },
      reason: {
        type: 'string',
        minLength: 1,
        maxLength: 2000,
        pattern: '^(?![\\s\\S]*<\\/?[A-Za-z][^>]*>)[\\s\\S]*$',
      },
    },
  },
  'POST /api/v1/reviews/{id}/finalize': {
    type: 'object',
    required: ['version', 'finalGrade'],
    additionalProperties: false,
    properties: {
      version: { type: 'integer', maximum: 9007199254740991 },
      finalGrade: { type: 'integer', minimum: 1, maximum: 5 },
      reason: {
        type: 'string',
        maxLength: 10000,
        pattern: '^(?![\\s\\S]*<\\/?[A-Za-z][^>]*>)[\\s\\S]*$',
      },
    },
  },
  'POST /api/v1/reviews/{id}/publish': {
    type: 'object',
    required: ['version'],
    additionalProperties: false,
    properties: { version: { type: 'integer', maximum: 9007199254740991 } },
  },
  'POST /api/v1/reviews/{id}/cancel': {
    type: 'object',
    required: ['version', 'reason'],
    additionalProperties: false,
    properties: {
      version: { type: 'integer', maximum: 9007199254740991 },
      reason: {
        type: 'string',
        minLength: 1,
        maxLength: 2000,
        pattern: '^(?![\\s\\S]*<\\/?[A-Za-z][^>]*>)[\\s\\S]*$',
      },
    },
  },
  'POST /api/v1/reviews/{id}/corrections': {
    type: 'object',
    required: ['version', 'reason', 'reviewDueAt'],
    additionalProperties: false,
    properties: {
      version: { type: 'integer', maximum: 9007199254740991 },
      reason: {
        type: 'string',
        minLength: 1,
        maxLength: 2000,
        pattern: '^(?![\\s\\S]*<\\/?[A-Za-z][^>]*>)[\\s\\S]*$',
      },
      reviewDueAt: {
        type: 'string',
        format: 'date-time',
        pattern:
          '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$',
      },
    },
  },
  'POST /api/v1/administrative/sections': {
    type: 'object',
    required: ['name', 'template'],
    additionalProperties: false,
    properties: {
      name: { type: 'string', minLength: 1, maxLength: 200 },
      template: { type: 'string', enum: ['TECHNICAL', 'PROXY'] },
    },
  },
  'PATCH /api/v1/administrative/sections/{id}': {
    type: 'object',
    required: ['version'],
    additionalProperties: false,
    properties: {
      name: { type: 'string', minLength: 1, maxLength: 200 },
      version: { type: 'integer', maximum: 9007199254740991 },
    },
  },
  'DELETE /api/v1/administrative/sections/{id}': {
    type: 'object',
    required: ['version'],
    additionalProperties: false,
    properties: { version: { type: 'integer', maximum: 9007199254740991 } },
  },
  'POST /api/v1/administrative/sheets': {
    type: 'object',
    required: ['sectionId', 'name', 'kind'],
    additionalProperties: false,
    properties: {
      sectionId: {
        type: 'string',
        format: 'uuid',
        pattern:
          '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
      },
      name: { type: 'string', minLength: 1, maxLength: 200 },
      kind: { type: 'string', enum: ['SERVER', 'DOMAIN', 'SERVICE', 'PROXY'] },
      customColumns: {
        type: 'array',
        maxItems: 50,
        items: {
          type: 'object',
          required: ['key', 'name', 'type'],
          additionalProperties: false,
          properties: {
            key: { type: 'string', pattern: '^[a-zA-Z][a-zA-Z0-9_]{0,49}$' },
            name: { type: 'string', minLength: 1, maxLength: 200 },
            type: { type: 'string', const: 'TEXT' },
          },
        },
      },
    },
  },
  'PATCH /api/v1/administrative/sheets/{id}': {
    type: 'object',
    required: ['version'],
    additionalProperties: false,
    properties: {
      name: { type: 'string', minLength: 1, maxLength: 200 },
      customColumns: {
        type: 'array',
        maxItems: 50,
        items: {
          type: 'object',
          required: ['key', 'name', 'type'],
          additionalProperties: false,
          properties: {
            key: { type: 'string', pattern: '^[a-zA-Z][a-zA-Z0-9_]{0,49}$' },
            name: { type: 'string', minLength: 1, maxLength: 200 },
            type: { type: 'string', const: 'TEXT' },
          },
        },
      },
      version: { type: 'integer', maximum: 9007199254740991 },
    },
  },
  'DELETE /api/v1/administrative/sheets/{id}': {
    type: 'object',
    required: ['version'],
    additionalProperties: false,
    properties: {
      version: { type: 'integer', maximum: 9007199254740991 },
      resolution: { type: 'string', enum: ['TRANSFER', 'TRASH'] },
      replacementId: {
        type: 'string',
        format: 'uuid',
        pattern:
          '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
      },
    },
  },
  'POST /api/v1/administrative/resources': {
    type: 'object',
    required: ['sheetId', 'name'],
    additionalProperties: false,
    properties: {
      sheetId: {
        type: 'string',
        format: 'uuid',
        pattern:
          '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
      },
      name: { type: 'string', minLength: 1, maxLength: 200 },
      metadata: {
        type: 'object',
        additionalProperties: false,
        properties: {
          ip: { type: 'string', maxLength: 253 },
          os: { type: 'string', maxLength: 300 },
          domain: { type: 'string', maxLength: 253 },
          serviceTypeId: {
            type: 'string',
            format: 'uuid',
            pattern:
              '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
          },
          host: { type: 'string', maxLength: 253 },
          port: { type: 'integer', minimum: 1, maximum: 65535 },
          protocol: { type: 'string', enum: ['HTTP', 'HTTPS', 'SOCKS5'] },
          geo: { type: 'string', maxLength: 100 },
          assignment: { type: 'string', maxLength: 500 },
        },
      },
      customValues: { type: 'object', additionalProperties: { type: 'string', maxLength: 10000 } },
      projectId: {
        type: 'string',
        format: 'uuid',
        pattern:
          '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
        nullable: true,
      },
      providerAccountId: {
        type: 'string',
        format: 'uuid',
        pattern:
          '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
        nullable: true,
      },
      paymentPeriodId: {
        type: 'string',
        format: 'uuid',
        pattern:
          '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
        nullable: true,
      },
      paymentMethodId: {
        type: 'string',
        format: 'uuid',
        pattern:
          '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
        nullable: true,
      },
      statusId: {
        type: 'string',
        format: 'uuid',
        pattern:
          '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
        nullable: true,
      },
      relevanceId: {
        type: 'string',
        format: 'uuid',
        pattern:
          '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
        nullable: true,
      },
      cost: { type: 'string', pattern: '^(0|[1-9]\\d{0,15})\\.\\d{2}$', nullable: true },
      currency: { type: 'string', enum: ['USD', 'EUR', 'RUB'], nullable: true },
      priceKind: { type: 'string', enum: ['PAID', 'FREE', 'UNKNOWN'] },
      paidUntil: {
        type: 'string',
        format: 'date',
        pattern:
          '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))$',
        nullable: true,
      },
      comment: { type: 'string', maxLength: 10000, nullable: true },
      responsibleAccountId: {
        type: 'string',
        format: 'uuid',
        pattern:
          '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
        nullable: true,
      },
      autoRenew: { type: 'boolean' },
      credentials: {
        type: 'object',
        additionalProperties: false,
        properties: {
          login: { type: 'string', maxLength: 500 },
          password: { type: 'string', maxLength: 500 },
        },
        nullable: true,
      },
    },
  },
  'POST /api/v1/administrative/resources/bulk': {
    type: 'object',
    required: ['items', 'action'],
    additionalProperties: false,
    properties: {
      items: {
        type: 'array',
        minItems: 1,
        maxItems: 100,
        items: {
          type: 'object',
          required: ['id', 'version'],
          additionalProperties: false,
          properties: {
            id: {
              type: 'string',
              format: 'uuid',
              pattern:
                '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
            },
            version: { type: 'integer', maximum: 9007199254740991 },
          },
        },
      },
      action: { type: 'string', enum: ['UPDATE', 'ARCHIVE', 'TRASH', 'RENEW'] },
      patch: {
        type: 'object',
        additionalProperties: false,
        properties: {
          sheetId: {
            type: 'string',
            format: 'uuid',
            pattern:
              '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
          },
          name: { type: 'string', minLength: 1, maxLength: 200 },
          metadata: {
            type: 'object',
            additionalProperties: false,
            properties: {
              ip: { type: 'string', maxLength: 253 },
              os: { type: 'string', maxLength: 300 },
              domain: { type: 'string', maxLength: 253 },
              serviceTypeId: {
                type: 'string',
                format: 'uuid',
                pattern:
                  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
              },
              host: { type: 'string', maxLength: 253 },
              port: { type: 'integer', minimum: 1, maximum: 65535 },
              protocol: { type: 'string', enum: ['HTTP', 'HTTPS', 'SOCKS5'] },
              geo: { type: 'string', maxLength: 100 },
              assignment: { type: 'string', maxLength: 500 },
            },
          },
          customValues: {
            type: 'object',
            additionalProperties: { type: 'string', maxLength: 10000 },
          },
          projectId: {
            type: 'string',
            format: 'uuid',
            pattern:
              '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
            nullable: true,
          },
          providerAccountId: {
            type: 'string',
            format: 'uuid',
            pattern:
              '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
            nullable: true,
          },
          paymentPeriodId: {
            type: 'string',
            format: 'uuid',
            pattern:
              '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
            nullable: true,
          },
          paymentMethodId: {
            type: 'string',
            format: 'uuid',
            pattern:
              '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
            nullable: true,
          },
          statusId: {
            type: 'string',
            format: 'uuid',
            pattern:
              '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
            nullable: true,
          },
          relevanceId: {
            type: 'string',
            format: 'uuid',
            pattern:
              '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
            nullable: true,
          },
          cost: { type: 'string', pattern: '^(0|[1-9]\\d{0,15})\\.\\d{2}$', nullable: true },
          currency: { type: 'string', enum: ['USD', 'EUR', 'RUB'], nullable: true },
          priceKind: { type: 'string', enum: ['PAID', 'FREE', 'UNKNOWN'] },
          paidUntil: {
            type: 'string',
            format: 'date',
            pattern:
              '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))$',
            nullable: true,
          },
          comment: { type: 'string', maxLength: 10000, nullable: true },
          responsibleAccountId: {
            type: 'string',
            format: 'uuid',
            pattern:
              '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
            nullable: true,
          },
          autoRenew: { type: 'boolean' },
          credentials: {
            type: 'object',
            additionalProperties: false,
            properties: {
              login: { type: 'string', maxLength: 500 },
              password: { type: 'string', maxLength: 500 },
            },
            nullable: true,
          },
        },
      },
      renewal: {
        type: 'object',
        required: ['paymentDate', 'amount', 'currency', 'paidUntil', 'operationKey'],
        additionalProperties: false,
        properties: {
          paymentDate: {
            type: 'string',
            format: 'date',
            pattern:
              '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))$',
          },
          amount: { type: 'string', pattern: '^(0|[1-9]\\d{0,15})\\.\\d{2}$' },
          currency: { type: 'string', enum: ['USD', 'EUR', 'RUB'] },
          paidUntil: {
            type: 'string',
            format: 'date',
            pattern:
              '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))$',
          },
          paymentMethodId: {
            type: 'string',
            format: 'uuid',
            pattern:
              '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
            nullable: true,
          },
          comment: { type: 'string', maxLength: 2000, nullable: true },
          operationKey: { type: 'string', minLength: 8, maxLength: 128 },
        },
      },
    },
  },
  'PATCH /api/v1/administrative/resources/{id}': {
    type: 'object',
    required: ['version'],
    additionalProperties: false,
    properties: {
      sheetId: {
        type: 'string',
        format: 'uuid',
        pattern:
          '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
      },
      name: { type: 'string', minLength: 1, maxLength: 200 },
      metadata: {
        type: 'object',
        additionalProperties: false,
        properties: {
          ip: { type: 'string', maxLength: 253 },
          os: { type: 'string', maxLength: 300 },
          domain: { type: 'string', maxLength: 253 },
          serviceTypeId: {
            type: 'string',
            format: 'uuid',
            pattern:
              '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
          },
          host: { type: 'string', maxLength: 253 },
          port: { type: 'integer', minimum: 1, maximum: 65535 },
          protocol: { type: 'string', enum: ['HTTP', 'HTTPS', 'SOCKS5'] },
          geo: { type: 'string', maxLength: 100 },
          assignment: { type: 'string', maxLength: 500 },
        },
      },
      customValues: { type: 'object', additionalProperties: { type: 'string', maxLength: 10000 } },
      projectId: {
        type: 'string',
        format: 'uuid',
        pattern:
          '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
        nullable: true,
      },
      providerAccountId: {
        type: 'string',
        format: 'uuid',
        pattern:
          '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
        nullable: true,
      },
      paymentPeriodId: {
        type: 'string',
        format: 'uuid',
        pattern:
          '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
        nullable: true,
      },
      paymentMethodId: {
        type: 'string',
        format: 'uuid',
        pattern:
          '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
        nullable: true,
      },
      statusId: {
        type: 'string',
        format: 'uuid',
        pattern:
          '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
        nullable: true,
      },
      relevanceId: {
        type: 'string',
        format: 'uuid',
        pattern:
          '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
        nullable: true,
      },
      cost: { type: 'string', pattern: '^(0|[1-9]\\d{0,15})\\.\\d{2}$', nullable: true },
      currency: { type: 'string', enum: ['USD', 'EUR', 'RUB'], nullable: true },
      priceKind: { type: 'string', enum: ['PAID', 'FREE', 'UNKNOWN'] },
      paidUntil: {
        type: 'string',
        format: 'date',
        pattern:
          '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))$',
        nullable: true,
      },
      comment: { type: 'string', maxLength: 10000, nullable: true },
      responsibleAccountId: {
        type: 'string',
        format: 'uuid',
        pattern:
          '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
        nullable: true,
      },
      autoRenew: { type: 'boolean' },
      credentials: {
        type: 'object',
        additionalProperties: false,
        properties: {
          login: { type: 'string', maxLength: 500 },
          password: { type: 'string', maxLength: 500 },
        },
        nullable: true,
      },
      version: { type: 'integer', maximum: 9007199254740991 },
    },
  },
  'POST /api/v1/administrative/resources/{id}/archive': {
    type: 'object',
    required: ['version'],
    additionalProperties: false,
    properties: { version: { type: 'integer', maximum: 9007199254740991 } },
  },
  'POST /api/v1/administrative/resources/{id}/unarchive': {
    type: 'object',
    required: ['version'],
    additionalProperties: false,
    properties: { version: { type: 'integer', maximum: 9007199254740991 } },
  },
  'POST /api/v1/administrative/resources/{id}/trash': {
    type: 'object',
    required: ['version'],
    additionalProperties: false,
    properties: { version: { type: 'integer', maximum: 9007199254740991 } },
  },
  'POST /api/v1/administrative/resources/{id}/restore': {
    type: 'object',
    required: ['version'],
    additionalProperties: false,
    properties: {
      version: { type: 'integer', maximum: 9007199254740991 },
      sheetId: {
        type: 'string',
        format: 'uuid',
        pattern:
          '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
      },
      projectId: {
        type: 'string',
        format: 'uuid',
        pattern:
          '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
        nullable: true,
      },
      providerAccountId: {
        type: 'string',
        format: 'uuid',
        pattern:
          '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
        nullable: true,
      },
    },
  },
  'POST /api/v1/administrative/resources/{id}/purge': {
    type: 'object',
    required: ['version'],
    additionalProperties: false,
    properties: { version: { type: 'integer', maximum: 9007199254740991 } },
  },
  'POST /api/v1/administrative/resources/{id}/renew-preview': {
    type: 'object',
    required: ['version'],
    additionalProperties: false,
    properties: { version: { type: 'integer', maximum: 9007199254740991 } },
  },
  'POST /api/v1/administrative/resources/{id}/renew': {
    type: 'object',
    required: ['version', 'paymentDate', 'amount', 'currency', 'paidUntil', 'operationKey'],
    additionalProperties: false,
    properties: {
      version: { type: 'integer', maximum: 9007199254740991 },
      paymentDate: {
        type: 'string',
        format: 'date',
        pattern:
          '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))$',
      },
      amount: { type: 'string', pattern: '^(0|[1-9]\\d{0,15})\\.\\d{2}$' },
      currency: { type: 'string', enum: ['USD', 'EUR', 'RUB'] },
      paidUntil: {
        type: 'string',
        format: 'date',
        pattern:
          '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))$',
      },
      paymentMethodId: {
        type: 'string',
        format: 'uuid',
        pattern:
          '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
        nullable: true,
      },
      comment: { type: 'string', maxLength: 2000, nullable: true },
      operationKey: { type: 'string', minLength: 8, maxLength: 128 },
    },
  },
  'POST /api/v1/administrative/resources/{id}/links': {
    type: 'object',
    required: ['version', 'targetResourceId', 'label'],
    additionalProperties: false,
    properties: {
      version: { type: 'integer', maximum: 9007199254740991 },
      targetResourceId: {
        type: 'string',
        format: 'uuid',
        pattern:
          '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
      },
      label: { type: 'string', minLength: 1, maxLength: 200 },
    },
  },
  'DELETE /api/v1/administrative/resources/{id}/links/{linkId}': {
    type: 'object',
    required: ['version'],
    additionalProperties: false,
    properties: { version: { type: 'integer', maximum: 9007199254740991 } },
  },
  'POST /api/v1/administrative/providers': {
    type: 'object',
    required: ['name'],
    additionalProperties: false,
    properties: {
      name: { type: 'string', minLength: 1, maxLength: 200 },
      serviceUrl: { type: 'string', format: 'uri', maxLength: 2000, nullable: true },
      login: { type: 'string', maxLength: 500, nullable: true },
      comment: { type: 'string', maxLength: 10000, nullable: true },
    },
  },
  'PATCH /api/v1/administrative/providers/{id}': {
    type: 'object',
    required: ['version'],
    additionalProperties: false,
    properties: {
      name: { type: 'string', minLength: 1, maxLength: 200 },
      serviceUrl: { type: 'string', format: 'uri', maxLength: 2000, nullable: true },
      login: { type: 'string', maxLength: 500, nullable: true },
      comment: { type: 'string', maxLength: 10000, nullable: true },
      version: { type: 'integer', maximum: 9007199254740991 },
    },
  },
  'DELETE /api/v1/administrative/providers/{id}': {
    type: 'object',
    required: ['version'],
    additionalProperties: false,
    properties: {
      version: { type: 'integer', maximum: 9007199254740991 },
      resolution: { type: 'string', enum: ['TRANSFER', 'TRASH'] },
      replacementId: {
        type: 'string',
        format: 'uuid',
        pattern:
          '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
      },
    },
  },
  'POST /api/v1/administrative/providers/{id}/cards': {
    type: 'object',
    required: ['name', 'last4'],
    additionalProperties: false,
    properties: {
      name: { type: 'string', minLength: 1, maxLength: 200 },
      last4: { type: 'string', pattern: '^\\d{4}$' },
      comment: { type: 'string', maxLength: 2000, nullable: true },
    },
  },
  'PATCH /api/v1/administrative/providers/{id}/cards/{cardId}': {
    type: 'object',
    required: ['version'],
    additionalProperties: false,
    properties: {
      name: { type: 'string', minLength: 1, maxLength: 200 },
      last4: { type: 'string', pattern: '^\\d{4}$' },
      comment: { type: 'string', maxLength: 2000, nullable: true },
      version: { type: 'integer', maximum: 9007199254740991 },
    },
  },
  'DELETE /api/v1/administrative/providers/{id}/cards/{cardId}': {
    type: 'object',
    required: ['version'],
    additionalProperties: false,
    properties: { version: { type: 'integer', maximum: 9007199254740991 } },
  },
  'POST /api/v1/administrative/providers/{id}/balances': {
    type: 'object',
    required: ['version', 'currency', 'amount'],
    additionalProperties: false,
    properties: {
      version: { type: 'integer', minimum: 0, maximum: 9007199254740991 },
      currency: { type: 'string', enum: ['USD', 'EUR', 'RUB'] },
      amount: { type: 'string', pattern: '^-?(0|[1-9]\\d{0,15})\\.\\d{2}$' },
    },
  },
  'POST /api/v1/administrative/projects': {
    type: 'object',
    required: ['name'],
    additionalProperties: false,
    properties: {
      name: { type: 'string', minLength: 1, maxLength: 200 },
      kind: { type: 'string', enum: ['PERIOD', 'METHOD', 'STATUS', 'RELEVANCE', 'SERVICE_TYPE'] },
      durationUnit: { type: 'string', enum: ['DAY', 'MONTH', 'YEAR'], nullable: true },
      durationCount: { type: 'integer', minimum: 1, maximum: 366, nullable: true },
      isRelevant: { type: 'boolean', nullable: true },
    },
  },
  'PATCH /api/v1/administrative/projects/{id}': {
    type: 'object',
    required: ['version'],
    additionalProperties: false,
    properties: {
      name: { type: 'string', minLength: 1, maxLength: 200 },
      kind: { type: 'string', enum: ['PERIOD', 'METHOD', 'STATUS', 'RELEVANCE', 'SERVICE_TYPE'] },
      durationUnit: { type: 'string', enum: ['DAY', 'MONTH', 'YEAR'], nullable: true },
      durationCount: { type: 'integer', minimum: 1, maximum: 366, nullable: true },
      isRelevant: { type: 'boolean', nullable: true },
      version: { type: 'integer', maximum: 9007199254740991 },
    },
  },
  'DELETE /api/v1/administrative/projects/{id}': {
    type: 'object',
    required: ['version'],
    additionalProperties: false,
    properties: { version: { type: 'integer', maximum: 9007199254740991 } },
  },
  'POST /api/v1/administrative/dictionaries': {
    type: 'object',
    required: ['name'],
    additionalProperties: false,
    properties: {
      name: { type: 'string', minLength: 1, maxLength: 200 },
      kind: { type: 'string', enum: ['PERIOD', 'METHOD', 'STATUS', 'RELEVANCE', 'SERVICE_TYPE'] },
      durationUnit: { type: 'string', enum: ['DAY', 'MONTH', 'YEAR'], nullable: true },
      durationCount: { type: 'integer', minimum: 1, maximum: 366, nullable: true },
      isRelevant: { type: 'boolean', nullable: true },
    },
  },
  'PATCH /api/v1/administrative/dictionaries/{id}': {
    type: 'object',
    required: ['version'],
    additionalProperties: false,
    properties: {
      name: { type: 'string', minLength: 1, maxLength: 200 },
      kind: { type: 'string', enum: ['PERIOD', 'METHOD', 'STATUS', 'RELEVANCE', 'SERVICE_TYPE'] },
      durationUnit: { type: 'string', enum: ['DAY', 'MONTH', 'YEAR'], nullable: true },
      durationCount: { type: 'integer', minimum: 1, maximum: 366, nullable: true },
      isRelevant: { type: 'boolean', nullable: true },
      version: { type: 'integer', maximum: 9007199254740991 },
    },
  },
  'DELETE /api/v1/administrative/dictionaries/{id}': {
    type: 'object',
    required: ['version'],
    additionalProperties: false,
    properties: { version: { type: 'integer', maximum: 9007199254740991 } },
  },
  'POST /api/v1/administrative/roles': {
    type: 'object',
    required: ['name', 'rules'],
    additionalProperties: false,
    properties: {
      name: { type: 'string', minLength: 1, maxLength: 200 },
      rules: {
        type: 'array',
        maxItems: 500,
        items: {
          type: 'object',
          required: ['action', 'effect', 'scope'],
          additionalProperties: false,
          properties: {
            action: {
              type: 'string',
              enum: [
                'resource.read',
                'resource.create',
                'resource.edit',
                'resource.archive',
                'resource.delete',
                'section.read',
                'section.create',
                'section.edit',
                'section.delete',
                'sheet.read',
                'sheet.create',
                'sheet.edit',
                'sheet.delete',
                'provider.read',
                'provider.edit',
                'finance.read',
                'finance.edit',
                'connection.read',
                'connection.edit',
                'members.read',
                'members.edit',
                'roles.edit',
                'trash.read',
                'trash.restore',
                'trash.purge',
                'audit.read',
                'settings.read',
                'settings.edit',
                'export',
                'import',
                'proxy.check',
              ],
            },
            effect: { type: 'string', enum: ['ALLOW', 'DENY'] },
            scope: { type: 'string', enum: ['WORKSPACE', 'SECTION', 'SHEET', 'RESOURCE'] },
            targetId: {
              type: 'string',
              format: 'uuid',
              pattern:
                '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
              nullable: true,
            },
            ownOnly: { type: 'boolean' },
          },
        },
      },
    },
  },
  'PATCH /api/v1/administrative/roles/{id}': {
    type: 'object',
    required: ['version'],
    additionalProperties: false,
    properties: {
      name: { type: 'string', minLength: 1, maxLength: 200 },
      rules: {
        type: 'array',
        maxItems: 500,
        items: {
          type: 'object',
          required: ['action', 'effect', 'scope'],
          additionalProperties: false,
          properties: {
            action: {
              type: 'string',
              enum: [
                'resource.read',
                'resource.create',
                'resource.edit',
                'resource.archive',
                'resource.delete',
                'section.read',
                'section.create',
                'section.edit',
                'section.delete',
                'sheet.read',
                'sheet.create',
                'sheet.edit',
                'sheet.delete',
                'provider.read',
                'provider.edit',
                'finance.read',
                'finance.edit',
                'connection.read',
                'connection.edit',
                'members.read',
                'members.edit',
                'roles.edit',
                'trash.read',
                'trash.restore',
                'trash.purge',
                'audit.read',
                'settings.read',
                'settings.edit',
                'export',
                'import',
                'proxy.check',
              ],
            },
            effect: { type: 'string', enum: ['ALLOW', 'DENY'] },
            scope: { type: 'string', enum: ['WORKSPACE', 'SECTION', 'SHEET', 'RESOURCE'] },
            targetId: {
              type: 'string',
              format: 'uuid',
              pattern:
                '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
              nullable: true,
            },
            ownOnly: { type: 'boolean' },
          },
        },
      },
      version: { type: 'integer', maximum: 9007199254740991 },
    },
  },
  'DELETE /api/v1/administrative/roles/{id}': {
    type: 'object',
    required: ['version'],
    additionalProperties: false,
    properties: { version: { type: 'integer', maximum: 9007199254740991 } },
  },
  'PATCH /api/v1/administrative/members/{id}': {
    type: 'object',
    required: ['version', 'roleId'],
    additionalProperties: false,
    properties: {
      version: { type: 'integer', maximum: 9007199254740991 },
      roleId: {
        type: 'string',
        format: 'uuid',
        pattern:
          '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
      },
      blocked: { type: 'boolean' },
    },
  },
  'POST /api/v1/administrative/invites': {
    type: 'object',
    required: ['login', 'roleId'],
    additionalProperties: false,
    properties: {
      login: {
        type: 'string',
        format: 'email',
        pattern:
          "^(?!\\.)(?!.*\\.\\.)([A-Za-z0-9_'+\\-\\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\\-]*\\.)+[A-Za-z]{2,}$",
      },
      roleId: {
        type: 'string',
        format: 'uuid',
        pattern:
          '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
      },
      organizationId: {
        type: 'string',
        format: 'uuid',
        pattern:
          '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
      },
    },
  },
  'POST /api/v1/administrative/invites/{id}/revoke': {
    type: 'object',
    required: ['version'],
    additionalProperties: false,
    properties: { version: { type: 'integer', maximum: 9007199254740991 } },
  },
  'POST /api/v1/administrative/saved-filters': {
    type: 'object',
    required: ['name', 'filters'],
    additionalProperties: false,
    properties: {
      name: { type: 'string', minLength: 1, maxLength: 200 },
      filters: {
        type: 'object',
        additionalProperties: false,
        properties: {
          cursor: { type: 'string', maxLength: 2000 },
          limit: { type: 'integer', minimum: 1, maximum: 100 },
          search: { type: 'string', maxLength: 300 },
          sectionId: {
            type: 'string',
            format: 'uuid',
            pattern:
              '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
          },
          sheetId: {
            type: 'string',
            format: 'uuid',
            pattern:
              '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
          },
          projectId: {
            type: 'string',
            format: 'uuid',
            pattern:
              '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
          },
          providerAccountId: {
            type: 'string',
            format: 'uuid',
            pattern:
              '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
          },
          kind: { type: 'string', enum: ['SERVER', 'DOMAIN', 'SERVICE', 'PROXY'] },
          statusId: {
            type: 'string',
            format: 'uuid',
            pattern:
              '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
          },
          relevanceId: {
            type: 'string',
            format: 'uuid',
            pattern:
              '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
          },
          currency: { type: 'string', enum: ['USD', 'EUR', 'RUB'] },
          responsibleAccountId: {
            type: 'string',
            format: 'uuid',
            pattern:
              '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
          },
          mine: { type: 'string', enum: ['true', 'false'] },
          state: { type: 'string', enum: ['ACTIVE', 'ARCHIVED', 'TRASH', 'ALL'] },
          from: {
            type: 'string',
            format: 'date',
            pattern:
              '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))$',
          },
          to: {
            type: 'string',
            format: 'date',
            pattern:
              '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))$',
          },
          sort: { type: 'string', enum: ['name', 'paidUntil', 'cost'] },
          direction: { type: 'string', enum: ['asc', 'desc'] },
        },
      },
    },
  },
  'PATCH /api/v1/administrative/saved-filters/{id}': {
    type: 'object',
    required: ['version'],
    additionalProperties: false,
    properties: {
      name: { type: 'string', minLength: 1, maxLength: 200 },
      filters: {
        type: 'object',
        additionalProperties: false,
        properties: {
          cursor: { type: 'string', maxLength: 2000 },
          limit: { type: 'integer', minimum: 1, maximum: 100 },
          search: { type: 'string', maxLength: 300 },
          sectionId: {
            type: 'string',
            format: 'uuid',
            pattern:
              '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
          },
          sheetId: {
            type: 'string',
            format: 'uuid',
            pattern:
              '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
          },
          projectId: {
            type: 'string',
            format: 'uuid',
            pattern:
              '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
          },
          providerAccountId: {
            type: 'string',
            format: 'uuid',
            pattern:
              '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
          },
          kind: { type: 'string', enum: ['SERVER', 'DOMAIN', 'SERVICE', 'PROXY'] },
          statusId: {
            type: 'string',
            format: 'uuid',
            pattern:
              '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
          },
          relevanceId: {
            type: 'string',
            format: 'uuid',
            pattern:
              '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
          },
          currency: { type: 'string', enum: ['USD', 'EUR', 'RUB'] },
          responsibleAccountId: {
            type: 'string',
            format: 'uuid',
            pattern:
              '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
          },
          mine: { type: 'string', enum: ['true', 'false'] },
          state: { type: 'string', enum: ['ACTIVE', 'ARCHIVED', 'TRASH', 'ALL'] },
          from: {
            type: 'string',
            format: 'date',
            pattern:
              '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))$',
          },
          to: {
            type: 'string',
            format: 'date',
            pattern:
              '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))$',
          },
          sort: { type: 'string', enum: ['name', 'paidUntil', 'cost'] },
          direction: { type: 'string', enum: ['asc', 'desc'] },
        },
      },
      version: { type: 'integer', maximum: 9007199254740991 },
    },
  },
  'DELETE /api/v1/administrative/saved-filters/{id}': {
    type: 'object',
    required: ['version'],
    additionalProperties: false,
    properties: { version: { type: 'integer', maximum: 9007199254740991 } },
  },
  'PATCH /api/v1/administrative/integrations/settings': {
    type: 'object',
    required: [
      'version',
      'remindersEnabled',
      'proxyScheduleEnabled',
      'proxyScheduleMinutes',
      'proxyTimeoutMs',
      'proxyConcurrency',
      'proxyRetries',
    ],
    additionalProperties: false,
    properties: {
      version: { type: 'integer', minimum: 0, maximum: 9007199254740991 },
      remindersEnabled: { type: 'boolean' },
      proxyScheduleEnabled: { type: 'boolean' },
      proxyScheduleMinutes: { type: 'integer', minimum: 5, maximum: 10080 },
      proxyTimeoutMs: { type: 'integer', minimum: 1000, maximum: 30000 },
      proxyConcurrency: { type: 'integer', minimum: 1, maximum: 8 },
      proxyRetries: { type: 'integer', minimum: 0, maximum: 2 },
    },
  },
  'POST /api/v1/administrative/integrations/telegram/config': {
    type: 'object',
    required: ['token'],
    additionalProperties: false,
    properties: {
      token: { type: 'string', maxLength: 300, pattern: '^\\d{5,20}:[A-Za-z0-9_-]{20,}$' },
    },
  },
  'POST /api/v1/administrative/integrations/telegram/connect': {
    type: 'object',
    additionalProperties: false,
    properties: {},
  },
  'PATCH /api/v1/administrative/integrations/telegram/binding': {
    type: 'object',
    required: ['optedIn'],
    additionalProperties: false,
    properties: { optedIn: { type: 'boolean' } },
  },
  'POST /api/v1/administrative/integrations/imports/preview': {
    type: 'object',
    required: ['sheetId', 'csv'],
    additionalProperties: false,
    properties: {
      sheetId: {
        type: 'string',
        format: 'uuid',
        pattern:
          '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
      },
      kind: { type: 'string', enum: ['SERVER', 'DOMAIN', 'SERVICE', 'PROXY'] },
      csv: { type: 'string', minLength: 1, maxLength: 2000000 },
    },
  },
  'POST /api/v1/administrative/integrations/imports/{id}/commit': {
    type: 'object',
    additionalProperties: false,
    properties: {},
  },
  'POST /api/v1/administrative/integrations/proxy-checks': {
    type: 'object',
    required: ['resourceIds', 'operationKey'],
    additionalProperties: false,
    properties: {
      resourceIds: {
        type: 'array',
        minItems: 1,
        maxItems: 1000,
        items: {
          type: 'string',
          format: 'uuid',
          pattern:
            '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
        },
      },
      operationKey: { type: 'string', minLength: 8, maxLength: 128 },
    },
  },
  'POST /public/v1/administrative/telegram/{workspaceId}/webhook': {
    type: 'object',
    additionalProperties: {},
    properties: {
      update_id: { type: 'integer', minimum: -9007199254740991, maximum: 9007199254740991 },
      message: {
        type: 'object',
        required: ['chat'],
        additionalProperties: {},
        properties: {
          text: { type: 'string', maxLength: 4096 },
          chat: {
            type: 'object',
            required: ['id', 'type'],
            additionalProperties: {},
            properties: {
              id: { type: 'integer', minimum: -9007199254740991, maximum: 9007199254740991 },
              type: { type: 'string' },
            },
          },
          from: {
            type: 'object',
            required: ['id'],
            additionalProperties: {},
            properties: {
              id: { type: 'integer', minimum: -9007199254740991, maximum: 9007199254740991 },
              is_bot: { type: 'boolean' },
            },
          },
        },
      },
    },
  },
  'POST /api/v1/administrative/resources/duplicate-preview': {
    type: 'object',
    required: ['sheetId', 'name'],
    additionalProperties: false,
    properties: {
      sheetId: {
        type: 'string',
        format: 'uuid',
        pattern:
          '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
      },
      name: { type: 'string', minLength: 1, maxLength: 200 },
      metadata: {
        type: 'object',
        additionalProperties: false,
        properties: {
          ip: { type: 'string', maxLength: 253 },
          os: { type: 'string', maxLength: 300 },
          domain: { type: 'string', maxLength: 253 },
          serviceTypeId: {
            type: 'string',
            format: 'uuid',
            pattern:
              '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
          },
          host: { type: 'string', maxLength: 253 },
          port: { type: 'integer', minimum: 1, maximum: 65535 },
          protocol: { type: 'string', enum: ['HTTP', 'HTTPS', 'SOCKS5'] },
          geo: { type: 'string', maxLength: 100 },
          assignment: { type: 'string', maxLength: 500 },
        },
      },
      customValues: { type: 'object', additionalProperties: { type: 'string', maxLength: 10000 } },
      projectId: {
        type: 'string',
        format: 'uuid',
        pattern:
          '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
        nullable: true,
      },
      providerAccountId: {
        type: 'string',
        format: 'uuid',
        pattern:
          '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
        nullable: true,
      },
      paymentPeriodId: {
        type: 'string',
        format: 'uuid',
        pattern:
          '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
        nullable: true,
      },
      paymentMethodId: {
        type: 'string',
        format: 'uuid',
        pattern:
          '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
        nullable: true,
      },
      statusId: {
        type: 'string',
        format: 'uuid',
        pattern:
          '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
        nullable: true,
      },
      relevanceId: {
        type: 'string',
        format: 'uuid',
        pattern:
          '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
        nullable: true,
      },
      cost: { type: 'string', pattern: '^(0|[1-9]\\d{0,15})\\.\\d{2}$', nullable: true },
      currency: { type: 'string', enum: ['USD', 'EUR', 'RUB'], nullable: true },
      priceKind: { type: 'string', enum: ['PAID', 'FREE', 'UNKNOWN'] },
      paidUntil: {
        type: 'string',
        format: 'date',
        pattern:
          '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))$',
        nullable: true,
      },
      comment: { type: 'string', maxLength: 10000, nullable: true },
      responsibleAccountId: {
        type: 'string',
        format: 'uuid',
        pattern:
          '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
        nullable: true,
      },
      autoRenew: { type: 'boolean' },
      credentials: {
        type: 'object',
        additionalProperties: false,
        properties: {
          login: { type: 'string', maxLength: 500 },
          password: { type: 'string', maxLength: 500 },
        },
        nullable: true,
      },
    },
  },
  'POST /api/v1/administrative/providers/duplicate-preview': {
    type: 'object',
    required: ['name'],
    additionalProperties: false,
    properties: {
      name: { type: 'string', minLength: 1, maxLength: 200 },
      serviceUrl: { type: 'string', format: 'uri', maxLength: 2000, nullable: true },
      login: { type: 'string', maxLength: 500, nullable: true },
      comment: { type: 'string', maxLength: 10000, nullable: true },
    },
  },
  'POST /api/v1/positions': {
    type: 'object',
    required: ['organizationId', 'name'],
    additionalProperties: false,
    properties: {
      organizationId: { type: 'string', format: 'uuid' },
      name: { type: 'string', minLength: 1, maxLength: 200 },
      code: { type: 'string', maxLength: 200 },
      description: { type: ['string', 'null'], maxLength: 5000 },
    },
  },
  'PATCH /api/v1/positions/{positionId}': {
    type: 'object',
    required: ['version'],
    additionalProperties: false,
    properties: {
      version: { type: 'integer', minimum: 1 },
      name: { type: 'string', maxLength: 200 },
      code: { type: 'string', maxLength: 200 },
      description: { type: ['string', 'null'], maxLength: 5000 },
    },
  },
  'POST /api/v1/departments/{departmentId}/restore': {
    type: 'object',
    required: ['version'],
    properties: {
      version: { type: 'integer', minimum: 1 },
      reason: { type: 'string', minLength: 1, maxLength: 2000 },
    },
  },
  'POST /api/v1/departments/{departmentId}/delete': {
    type: 'object',
    required: ['version'],
    properties: {
      version: { type: 'integer', minimum: 1 },
      reason: { type: 'string', minLength: 1, maxLength: 2000 },
    },
  },
  'POST /api/v1/teams/{teamId}/restore': {
    type: 'object',
    required: ['version'],
    properties: {
      version: { type: 'integer', minimum: 1 },
      reason: { type: 'string', minLength: 1, maxLength: 2000 },
    },
  },
  'POST /api/v1/teams/{teamId}/delete': {
    type: 'object',
    required: ['version'],
    properties: {
      version: { type: 'integer', minimum: 1 },
      reason: { type: 'string', minLength: 1, maxLength: 2000 },
    },
  },
  'POST /api/v1/positions/{positionId}/archive': {
    type: 'object',
    required: ['version'],
    properties: {
      version: { type: 'integer', minimum: 1 },
      reason: { type: 'string', minLength: 1, maxLength: 2000 },
    },
  },
  'POST /api/v1/positions/{positionId}/restore': {
    type: 'object',
    required: ['version'],
    properties: {
      version: { type: 'integer', minimum: 1 },
      reason: { type: 'string', minLength: 1, maxLength: 2000 },
    },
  },
  'POST /api/v1/positions/{positionId}/delete': {
    type: 'object',
    required: ['version'],
    properties: {
      version: { type: 'integer', minimum: 1 },
      reason: { type: 'string', minLength: 1, maxLength: 2000 },
    },
  },
  'POST /api/v1/employees/{employeeId}/archive': {
    type: 'object',
    required: ['version'],
    properties: {
      version: { type: 'integer', minimum: 1 },
      reason: { type: 'string', minLength: 1, maxLength: 2000 },
    },
  },
  'POST /api/v1/employees/{employeeId}/restore': {
    type: 'object',
    required: ['version'],
    properties: {
      version: { type: 'integer', minimum: 1 },
      reason: { type: 'string', minLength: 1, maxLength: 2000 },
    },
  },
  'POST /api/v1/employees/{employeeId}/delete': {
    type: 'object',
    required: ['version'],
    properties: {
      version: { type: 'integer', minimum: 1 },
      reason: { type: 'string', minLength: 1, maxLength: 2000 },
    },
  },
  'POST /api/v1/employees/bulk': {
    type: 'object',
    required: ['employees', 'patch', 'reason'],
    additionalProperties: false,
    properties: {
      employees: {
        type: 'array',
        minItems: 1,
        maxItems: 250,
        items: {
          type: 'object',
          required: ['id', 'version'],
          additionalProperties: false,
          properties: {
            id: {
              type: 'string',
              format: 'uuid',
              pattern:
                '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
            },
            version: { type: 'integer', maximum: 9007199254740991 },
          },
        },
      },
      patch: {
        type: 'object',
        additionalProperties: false,
        properties: {
          departmentId: {
            type: 'string',
            format: 'uuid',
            pattern:
              '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
          },
          primaryTeamId: {
            type: 'string',
            format: 'uuid',
            pattern:
              '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
            nullable: true,
          },
          additionalTeamIds: {
            type: 'array',
            maxItems: 50,
            items: {
              type: 'string',
              format: 'uuid',
              pattern:
                '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
            },
          },
          lineManagerId: {
            type: 'string',
            format: 'uuid',
            pattern:
              '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
            nullable: true,
          },
          status: {
            type: 'string',
            enum: [
              'JOINING',
              'PROBATION',
              'ACTIVE',
              'ON_LEAVE',
              'INACTIVE',
              'OFFBOARDING',
              'ARCHIVED',
            ],
          },
          positionId: {
            type: 'string',
            format: 'uuid',
            pattern:
              '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
            nullable: true,
          },
          locationId: {
            type: 'string',
            format: 'uuid',
            pattern:
              '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
          },
          employmentType: { type: 'string', enum: ['FULL_TIME', 'PART_TIME', 'CONTRACTOR'] },
          workFormat: { type: 'string', enum: ['OFFICE', 'HYBRID', 'REMOTE'] },
        },
      },
      reason: { type: 'string', minLength: 1, maxLength: 2000 },
    },
  },
  'POST /api/v1/employees/import/preview': {
    type: 'object',
    required: ['organizationId', 'csv'],
    additionalProperties: false,
    properties: {
      organizationId: {
        type: 'string',
        format: 'uuid',
        pattern:
          '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
      },
      csv: { type: 'string', minLength: 1, maxLength: 1000000 },
    },
  },
  'POST /api/v1/employees/import': {
    type: 'object',
    required: ['organizationId', 'csv'],
    additionalProperties: false,
    properties: {
      organizationId: {
        type: 'string',
        format: 'uuid',
        pattern:
          '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
      },
      csv: { type: 'string', minLength: 1, maxLength: 1000000 },
      dryRun: { type: 'boolean' },
    },
  },
};
export const operationParameters = {
  'POST /public/v1/auth/login': {},
  'POST /public/v1/auth/mfa/email/send': {},
  'POST /public/v1/auth/mfa/verify': {},
  'POST /public/v1/auth/refresh': {},
  'POST /public/v1/auth/activation-sessions': {},
  'POST /public/v1/auth/activation/complete': {},
  'POST /public/v1/auth/password-reset/request': {},
  'POST /public/v1/auth/password-reset-sessions': {},
  'POST /public/v1/auth/password-reset/complete': {},
  'POST /api/v1/auth/logout': {},
  'POST /api/v1/auth/logout-all': {},
  'POST /api/v1/auth/change-password': {},
  'POST /api/v1/auth/mfa/email/enrollment': {},
  'POST /api/v1/auth/mfa/email/enrollment/verify': {},
  'POST /api/v1/auth/mfa/totp/enrollment': {},
  'POST /api/v1/auth/mfa/totp/enrollment/verify': {},
  'POST /api/v1/notifications/{notificationId}/read': {
    notificationId: { type: 'string', format: 'uuid' },
  },
  'POST /api/v1/notifications/read-all': {},
  'PUT /api/v1/notification-preferences/{category}': {
    category: {
      type: 'string',
      enum: [
        'ADMINISTRATIVE',
        'PERFORMANCE',
        'SECURITY_LOGIN',
        'SECURITY_ACCOUNT',
        'ACCESS',
        'HR_PROFILE',
        'RECRUITMENT',
        'APPROVALS',
        'INTERVIEWS',
        'OFFERS',
        'ONBOARDING',
        'OFFBOARDING',
        'FILES',
        'SYSTEM',
      ],
    },
  },
  'PATCH /api/v1/me/appearance': {},
  'POST /api/v1/accounts': {},
  'PATCH /api/v1/accounts/{accountId}/work-areas': {
    accountId: { type: 'string', format: 'uuid' },
  },
  'POST /api/v1/accounts/{accountId}/activation-links': {
    accountId: { type: 'string', format: 'uuid' },
  },
  'POST /api/v1/accounts/{accountId}/password-reset-links': {
    accountId: { type: 'string', format: 'uuid' },
  },
  'POST /api/v1/accounts/{accountId}/block': { accountId: { type: 'string', format: 'uuid' } },
  'POST /api/v1/accounts/{accountId}/unblock': { accountId: { type: 'string', format: 'uuid' } },
  'POST /api/v1/accounts/{accountId}/disable': { accountId: { type: 'string', format: 'uuid' } },
  'POST /api/v1/accounts/{accountId}/reactivate': { accountId: { type: 'string', format: 'uuid' } },
  'DELETE /api/v1/accounts/{accountId}/sessions/{sessionId}': {
    accountId: { type: 'string', format: 'uuid' },
    sessionId: { type: 'string', format: 'uuid' },
  },
  'POST /api/v1/permission-groups': {},
  'PATCH /api/v1/permission-groups/{groupId}': { groupId: { type: 'string', format: 'uuid' } },
  'PUT /api/v1/accounts/{accountId}/permission-assignments/{assignmentId}': {
    accountId: { type: 'string', format: 'uuid' },
    assignmentId: { type: 'string', format: 'uuid' },
  },
  'DELETE /api/v1/accounts/{accountId}/permission-assignments/{assignmentId}': {
    accountId: { type: 'string', format: 'uuid' },
    assignmentId: { type: 'string', format: 'uuid' },
  },
  'POST /api/v1/accounts/{accountId}/permission-overrides': {
    accountId: { type: 'string', format: 'uuid' },
  },
  'DELETE /api/v1/accounts/{accountId}/permission-overrides/{overrideId}': {
    accountId: { type: 'string', format: 'uuid' },
    overrideId: { type: 'string', format: 'uuid' },
  },
  'POST /api/v1/service-accounts': {},
  'POST /api/v1/service-accounts/{id}/rotate': { id: { type: 'string', format: 'uuid' } },
  'POST /api/v1/service-accounts/{id}/revoke': { id: { type: 'string', format: 'uuid' } },
  'PATCH /api/v1/workspace': {},
  'POST /api/v1/organizations': {},
  'PATCH /api/v1/organizations/{organizationId}': {
    organizationId: { type: 'string', format: 'uuid' },
  },
  'POST /api/v1/departments': {},
  'PATCH /api/v1/departments/{departmentId}': { departmentId: { type: 'string', format: 'uuid' } },
  'POST /api/v1/departments/{departmentId}/archive': {
    departmentId: { type: 'string', format: 'uuid' },
  },
  'POST /api/v1/teams': {},
  'PATCH /api/v1/teams/{teamId}': { teamId: { type: 'string', format: 'uuid' } },
  'POST /api/v1/teams/{teamId}/archive': { teamId: { type: 'string', format: 'uuid' } },
  'POST /api/v1/job-functions': {},
  'PATCH /api/v1/job-functions/{id}': { id: { type: 'string', format: 'uuid' } },
  'POST /api/v1/specialisations': {},
  'PATCH /api/v1/specialisations/{id}': { id: { type: 'string', format: 'uuid' } },
  'POST /api/v1/seniorities': {},
  'PATCH /api/v1/seniorities/{id}': { id: { type: 'string', format: 'uuid' } },
  'POST /api/v1/locations': {},
  'PATCH /api/v1/locations/{id}': { id: { type: 'string', format: 'uuid' } },
  'POST /api/v1/employees': {},
  'PATCH /api/v1/employees/{employeeId}/work-profile': {
    employeeId: { type: 'string', format: 'uuid' },
  },
  'POST /api/v1/employees/{employeeId}/change-work-email': {
    employeeId: { type: 'string', format: 'uuid' },
  },
  'POST /api/v1/employees/{employeeId}/activate': {
    employeeId: { type: 'string', format: 'uuid' },
  },
  'POST /api/v1/employees/{employeeId}/rehire': { employeeId: { type: 'string', format: 'uuid' } },
  'PATCH /api/v1/employees/{employeeId}/personal-details': {
    employeeId: { type: 'string', format: 'uuid' },
  },
  'POST /api/v1/employees/{employeeId}/documents': {
    employeeId: { type: 'string', format: 'uuid' },
  },
  'POST /api/v1/employees/{employeeId}/screenings': {
    employeeId: { type: 'string', format: 'uuid' },
  },
  'POST /api/v1/employees/{employeeId}/right-to-work': {
    employeeId: { type: 'string', format: 'uuid' },
  },
  'POST /api/v1/employees/{employeeId}/compensation': {
    employeeId: { type: 'string', format: 'uuid' },
  },
  'POST /api/v1/employees/{employeeId}/payroll': { employeeId: { type: 'string', format: 'uuid' } },
  'POST /api/v1/requisitions': {},
  'PATCH /api/v1/requisitions/{id}': { id: { type: 'string', format: 'uuid' } },
  'POST /api/v1/headcount-allocations': {},
  'POST /api/v1/requisitions/{id}/submit': { id: { type: 'string', format: 'uuid' } },
  'POST /api/v1/requisitions/{id}/approve': { id: { type: 'string', format: 'uuid' } },
  'POST /api/v1/requisitions/{id}/reject': { id: { type: 'string', format: 'uuid' } },
  'POST /api/v1/requisitions/{id}/hold': { id: { type: 'string', format: 'uuid' } },
  'POST /api/v1/requisitions/{id}/resume': { id: { type: 'string', format: 'uuid' } },
  'POST /api/v1/requisitions/{id}/close': { id: { type: 'string', format: 'uuid' } },
  'POST /api/v1/requisitions/{id}/reopen': { id: { type: 'string', format: 'uuid' } },
  'POST /api/v1/requisitions/{id}/archive': { id: { type: 'string', format: 'uuid' } },
  'POST /api/v1/job-postings': {},
  'PATCH /api/v1/job-postings/{id}': { id: { type: 'string', format: 'uuid' } },
  'POST /api/v1/job-postings/{id}/application-form-versions': {
    id: { type: 'string', format: 'uuid' },
  },
  'POST /api/v1/job-postings/{id}/pipeline-versions': { id: { type: 'string', format: 'uuid' } },
  'POST /api/v1/job-postings/{id}/submit-approval': { id: { type: 'string', format: 'uuid' } },
  'POST /api/v1/job-postings/{id}/approve': { id: { type: 'string', format: 'uuid' } },
  'POST /api/v1/job-postings/{id}/reject': { id: { type: 'string', format: 'uuid' } },
  'POST /api/v1/job-postings/{id}/publish': { id: { type: 'string', format: 'uuid' } },
  'POST /api/v1/job-postings/{id}/unpublish': { id: { type: 'string', format: 'uuid' } },
  'POST /api/v1/job-postings/{id}/hold': { id: { type: 'string', format: 'uuid' } },
  'POST /api/v1/job-postings/{id}/resume': { id: { type: 'string', format: 'uuid' } },
  'POST /api/v1/job-postings/{id}/close': { id: { type: 'string', format: 'uuid' } },
  'POST /api/v1/job-postings/{id}/reopen': { id: { type: 'string', format: 'uuid' } },
  'POST /api/v1/job-postings/{id}/archive': { id: { type: 'string', format: 'uuid' } },
  'POST /api/v1/candidates': {},
  'PATCH /api/v1/candidates/{id}': { id: { type: 'string', format: 'uuid' } },
  'POST /api/v1/candidates/imports': {},
  'POST /api/v1/candidates/merge': {},
  'POST /api/v1/privacy-notice-versions': {},
  'POST /api/v1/privacy-notice-versions/{id}/publish': { id: { type: 'string', format: 'uuid' } },
  'POST /api/v1/processing-basis-policy-versions': {},
  'POST /api/v1/processing-basis-policy-versions/{id}/activate': {
    id: { type: 'string', format: 'uuid' },
  },
  'POST /api/v1/candidates/{id}/processing-purposes': { id: { type: 'string', format: 'uuid' } },
  'POST /api/v1/candidates/{id}/privacy-notice-deliveries': {
    id: { type: 'string', format: 'uuid' },
  },
  'POST /api/v1/candidates/{id}/consents': { id: { type: 'string', format: 'uuid' } },
  'POST /api/v1/candidate-consents/{id}/revoke': { id: { type: 'string', format: 'uuid' } },
  'POST /api/v1/applications': {},
  'POST /api/v1/applications/{id}/change-stage': { id: { type: 'string', format: 'uuid' } },
  'POST /api/v1/applications/{id}/reject': { id: { type: 'string', format: 'uuid' } },
  'POST /api/v1/applications/{id}/withdraw': { id: { type: 'string', format: 'uuid' } },
  'POST /api/v1/applications/{id}/archive': { id: { type: 'string', format: 'uuid' } },
  'POST /api/v1/applications/{id}/interviews': { id: { type: 'string', format: 'uuid' } },
  'POST /api/v1/interviews/{id}/reschedule': { id: { type: 'string', format: 'uuid' } },
  'POST /api/v1/interviews/{id}/cancel': { id: { type: 'string', format: 'uuid' } },
  'POST /api/v1/interviews/{id}/complete': { id: { type: 'string', format: 'uuid' } },
  'POST /api/v1/interviews/{id}/no-show': { id: { type: 'string', format: 'uuid' } },
  'POST /api/v1/interviews/{id}/feedback': { id: { type: 'string', format: 'uuid' } },
  'POST /api/v1/applications/{id}/offers': { id: { type: 'string', format: 'uuid' } },
  'POST /api/v1/offers/{id}/versions': { id: { type: 'string', format: 'uuid' } },
  'POST /api/v1/offers/{id}/submit-approval': { id: { type: 'string', format: 'uuid' } },
  'POST /api/v1/offers/{id}/approve': { id: { type: 'string', format: 'uuid' } },
  'POST /api/v1/offers/{id}/reject': { id: { type: 'string', format: 'uuid' } },
  'POST /api/v1/offers/{id}/send': { id: { type: 'string', format: 'uuid' } },
  'POST /api/v1/offers/{id}/withdraw': { id: { type: 'string', format: 'uuid' } },
  'POST /api/v1/applications/{id}/hire': { id: { type: 'string', format: 'uuid' } },
  'POST /api/v1/process-templates': {},
  'POST /api/v1/process-templates/{id}/versions': { id: { type: 'string', format: 'uuid' } },
  'POST /api/v1/process-template-versions/{id}/publish': { id: { type: 'string', format: 'uuid' } },
  'POST /api/v1/onboarding-processes': {},
  'POST /api/v1/onboarding-processes/{id}/start': { id: { type: 'string', format: 'uuid' } },
  'POST /api/v1/onboarding-processes/{id}/complete': { id: { type: 'string', format: 'uuid' } },
  'POST /api/v1/onboarding-processes/{id}/cancel': { id: { type: 'string', format: 'uuid' } },
  'POST /api/v1/offboarding-processes': {},
  'POST /api/v1/offboarding-processes/{id}/start': { id: { type: 'string', format: 'uuid' } },
  'POST /api/v1/offboarding-processes/{id}/complete': { id: { type: 'string', format: 'uuid' } },
  'POST /api/v1/offboarding-processes/{id}/cancel': { id: { type: 'string', format: 'uuid' } },
  'POST /api/v1/offboarding-processes/{id}/access-extension': {
    id: { type: 'string', format: 'uuid' },
  },
  'DELETE /api/v1/offboarding-processes/{id}/access-extension': {
    id: { type: 'string', format: 'uuid' },
  },
  'POST /api/v1/offboarding-processes/{id}/disable-access-now': {
    id: { type: 'string', format: 'uuid' },
  },
  'POST /api/v1/process-tasks/{id}/complete': { id: { type: 'string', format: 'uuid' } },
  'POST /api/v1/files': {},
  'POST /api/v1/files/{id}/download-url': { id: { type: 'string', format: 'uuid' } },
  'POST /api/v1/exports': {},
  'POST /api/v1/retention-policies': {},
  'PATCH /api/v1/retention-policies/{id}': { id: { type: 'string', format: 'uuid' } },
  'POST /api/v1/retention-runs/dry-run': {},
  'POST /api/v1/legal-holds': {},
  'POST /api/v1/legal-holds/{id}/release': { id: { type: 'string', format: 'uuid' } },
  'POST /public/v1/job-postings/{publicId}/application-upload-sessions': {
    publicId: { type: 'string', format: 'uuid' },
  },
  'POST /public/v1/job-postings/{publicId}/applications': {
    publicId: { type: 'string', format: 'uuid' },
  },
  'POST /public/v1/application-files': {},
  'POST /public/v1/offer-access-sessions': {},
  'POST /public/v1/offers/current/view': {},
  'POST /public/v1/offers/current/decision': {},
  'POST /public/v1/privacy-requests/consent-withdrawal-links': {},
  'POST /public/v1/consent-withdrawal-sessions': {},
  'POST /public/v1/consents/current/withdraw': {},
  'POST /api/v1/skills': {},
  'PATCH /api/v1/skills/{id}': { id: { type: 'string', format: 'uuid' } },
  'POST /api/v1/skills/{id}/archive': { id: { type: 'string', format: 'uuid' } },
  'POST /api/v1/skills/{id}/versions': { id: { type: 'string', format: 'uuid' } },
  'PATCH /api/v1/skill-versions/{id}': { id: { type: 'string', format: 'uuid' } },
  'POST /api/v1/skill-versions/{id}/publish': { id: { type: 'string', format: 'uuid' } },
  'POST /api/v1/skill-versions/{id}/retire': { id: { type: 'string', format: 'uuid' } },
  'POST /api/v1/role-profiles': {},
  'PATCH /api/v1/role-profiles/{id}': { id: { type: 'string', format: 'uuid' } },
  'POST /api/v1/role-profiles/{id}/archive': { id: { type: 'string', format: 'uuid' } },
  'POST /api/v1/role-profiles/{id}/versions': { id: { type: 'string', format: 'uuid' } },
  'PATCH /api/v1/role-profile-versions/{id}': { id: { type: 'string', format: 'uuid' } },
  'POST /api/v1/role-profile-versions/{id}/publish': { id: { type: 'string', format: 'uuid' } },
  'POST /api/v1/role-profile-versions/{id}/retire': { id: { type: 'string', format: 'uuid' } },
  'POST /api/v1/employee-evaluation-templates': {},
  'PATCH /api/v1/employee-evaluation-templates/{id}': { id: { type: 'string', format: 'uuid' } },
  'POST /api/v1/employee-evaluation-templates/{id}/archive': {
    id: { type: 'string', format: 'uuid' },
  },
  'POST /api/v1/employee-evaluation-templates/{id}/versions': {
    id: { type: 'string', format: 'uuid' },
  },
  'PATCH /api/v1/employee-evaluation-template-versions/{id}': {
    id: { type: 'string', format: 'uuid' },
  },
  'POST /api/v1/employee-evaluation-template-versions/{id}/publish': {
    id: { type: 'string', format: 'uuid' },
  },
  'POST /api/v1/employee-evaluation-template-versions/{id}/retire': {
    id: { type: 'string', format: 'uuid' },
  },
  'PUT /api/v1/specialisations/{id}/allowed-seniorities': {
    id: { type: 'string', format: 'uuid' },
  },
  'POST /api/v1/employees/{id}/role-profile-assignments': {
    id: { type: 'string', format: 'uuid' },
  },
  'POST /api/v1/performance-cycles': {},
  'PATCH /api/v1/performance-cycles/{id}': { id: { type: 'string', format: 'uuid' } },
  'POST /api/v1/performance-cycles/{id}/activate': { id: { type: 'string', format: 'uuid' } },
  'POST /api/v1/performance-cycles/{id}/close': { id: { type: 'string', format: 'uuid' } },
  'POST /api/v1/performance-cycles/{id}/cancel': { id: { type: 'string', format: 'uuid' } },
  'POST /api/v1/employees/{id}/work-plans': { id: { type: 'string', format: 'uuid' } },
  'PATCH /api/v1/work-plans/{id}': { id: { type: 'string', format: 'uuid' } },
  'POST /api/v1/work-plans/{id}/activate': { id: { type: 'string', format: 'uuid' } },
  'POST /api/v1/work-plans/{id}/cancel': { id: { type: 'string', format: 'uuid' } },
  'POST /api/v1/work-plans/{id}/tasks': { id: { type: 'string', format: 'uuid' } },
  'PATCH /api/v1/work-tasks/{id}': { id: { type: 'string', format: 'uuid' } },
  'PATCH /api/v1/work-tasks/{id}/progress': { id: { type: 'string', format: 'uuid' } },
  'POST /api/v1/work-tasks/{id}/start': { id: { type: 'string', format: 'uuid' } },
  'POST /api/v1/work-tasks/{id}/submit': { id: { type: 'string', format: 'uuid' } },
  'POST /api/v1/work-tasks/{id}/accept': { id: { type: 'string', format: 'uuid' } },
  'POST /api/v1/work-tasks/{id}/return': { id: { type: 'string', format: 'uuid' } },
  'POST /api/v1/work-tasks/{id}/exclude': { id: { type: 'string', format: 'uuid' } },
  'POST /api/v1/work-plans/{id}/reviews': { id: { type: 'string', format: 'uuid' } },
  'POST /api/v1/reviews/{id}/open': { id: { type: 'string', format: 'uuid' } },
  'POST /api/v1/reviews/{id}/reviewer': { id: { type: 'string', format: 'uuid' } },
  'PATCH /api/v1/reviews/{id}/submissions/{type}': {
    id: { type: 'string', format: 'uuid' },
    type: { type: 'string', enum: ['SELF', 'LINE_MANAGER'] },
  },
  'POST /api/v1/reviews/{id}/submissions/{type}/submit': {
    id: { type: 'string', format: 'uuid' },
    type: { type: 'string', enum: ['SELF', 'LINE_MANAGER'] },
  },
  'POST /api/v1/reviews/{id}/submissions/{type}/return': {
    id: { type: 'string', format: 'uuid' },
    type: { type: 'string', enum: ['SELF', 'LINE_MANAGER'] },
  },
  'POST /api/v1/reviews/{id}/finalize': { id: { type: 'string', format: 'uuid' } },
  'POST /api/v1/reviews/{id}/publish': { id: { type: 'string', format: 'uuid' } },
  'POST /api/v1/reviews/{id}/cancel': { id: { type: 'string', format: 'uuid' } },
  'POST /api/v1/reviews/{id}/corrections': { id: { type: 'string', format: 'uuid' } },
  'POST /api/v1/administrative/sections': {},
  'PATCH /api/v1/administrative/sections/{id}': { id: { type: 'string', format: 'uuid' } },
  'DELETE /api/v1/administrative/sections/{id}': { id: { type: 'string', format: 'uuid' } },
  'POST /api/v1/administrative/sheets': {},
  'PATCH /api/v1/administrative/sheets/{id}': { id: { type: 'string', format: 'uuid' } },
  'DELETE /api/v1/administrative/sheets/{id}': { id: { type: 'string', format: 'uuid' } },
  'POST /api/v1/administrative/resources': {},
  'POST /api/v1/administrative/resources/bulk': {},
  'PATCH /api/v1/administrative/resources/{id}': { id: { type: 'string', format: 'uuid' } },
  'POST /api/v1/administrative/resources/{id}/archive': { id: { type: 'string', format: 'uuid' } },
  'POST /api/v1/administrative/resources/{id}/unarchive': {
    id: { type: 'string', format: 'uuid' },
  },
  'POST /api/v1/administrative/resources/{id}/trash': { id: { type: 'string', format: 'uuid' } },
  'POST /api/v1/administrative/resources/{id}/restore': { id: { type: 'string', format: 'uuid' } },
  'POST /api/v1/administrative/resources/{id}/purge': { id: { type: 'string', format: 'uuid' } },
  'POST /api/v1/administrative/resources/{id}/renew-preview': {
    id: { type: 'string', format: 'uuid' },
  },
  'POST /api/v1/administrative/resources/{id}/renew': { id: { type: 'string', format: 'uuid' } },
  'POST /api/v1/administrative/resources/{id}/links': { id: { type: 'string', format: 'uuid' } },
  'DELETE /api/v1/administrative/resources/{id}/links/{linkId}': {
    id: { type: 'string', format: 'uuid' },
    linkId: { type: 'string', format: 'uuid' },
  },
  'POST /api/v1/administrative/providers': {},
  'PATCH /api/v1/administrative/providers/{id}': { id: { type: 'string', format: 'uuid' } },
  'DELETE /api/v1/administrative/providers/{id}': { id: { type: 'string', format: 'uuid' } },
  'POST /api/v1/administrative/providers/{id}/cards': { id: { type: 'string', format: 'uuid' } },
  'PATCH /api/v1/administrative/providers/{id}/cards/{cardId}': {
    id: { type: 'string', format: 'uuid' },
    cardId: { type: 'string', format: 'uuid' },
  },
  'DELETE /api/v1/administrative/providers/{id}/cards/{cardId}': {
    id: { type: 'string', format: 'uuid' },
    cardId: { type: 'string', format: 'uuid' },
  },
  'POST /api/v1/administrative/providers/{id}/balances': { id: { type: 'string', format: 'uuid' } },
  'POST /api/v1/administrative/projects': {},
  'PATCH /api/v1/administrative/projects/{id}': { id: { type: 'string', format: 'uuid' } },
  'DELETE /api/v1/administrative/projects/{id}': { id: { type: 'string', format: 'uuid' } },
  'POST /api/v1/administrative/dictionaries': {},
  'PATCH /api/v1/administrative/dictionaries/{id}': { id: { type: 'string', format: 'uuid' } },
  'DELETE /api/v1/administrative/dictionaries/{id}': { id: { type: 'string', format: 'uuid' } },
  'POST /api/v1/administrative/roles': {},
  'PATCH /api/v1/administrative/roles/{id}': { id: { type: 'string', format: 'uuid' } },
  'DELETE /api/v1/administrative/roles/{id}': { id: { type: 'string', format: 'uuid' } },
  'PATCH /api/v1/administrative/members/{id}': { id: { type: 'string', format: 'uuid' } },
  'POST /api/v1/administrative/invites': {},
  'POST /api/v1/administrative/invites/{id}/revoke': { id: { type: 'string', format: 'uuid' } },
  'POST /api/v1/administrative/saved-filters': {},
  'PATCH /api/v1/administrative/saved-filters/{id}': { id: { type: 'string', format: 'uuid' } },
  'DELETE /api/v1/administrative/saved-filters/{id}': { id: { type: 'string', format: 'uuid' } },
  'PATCH /api/v1/administrative/integrations/settings': {},
  'POST /api/v1/administrative/integrations/telegram/config': {},
  'POST /api/v1/administrative/integrations/telegram/connect': {},
  'PATCH /api/v1/administrative/integrations/telegram/binding': {},
  'POST /api/v1/administrative/integrations/imports/preview': {},
  'POST /api/v1/administrative/integrations/imports/{id}/commit': {
    id: { type: 'string', format: 'uuid' },
  },
  'POST /api/v1/administrative/integrations/proxy-checks': {},
  'POST /public/v1/administrative/telegram/{workspaceId}/webhook': {
    workspaceId: { type: 'string', format: 'uuid' },
  },
  'POST /api/v1/administrative/resources/duplicate-preview': {},
  'POST /api/v1/administrative/providers/duplicate-preview': {},
  'POST /api/v1/positions': {},
  'PATCH /api/v1/positions/{positionId}': { positionId: { type: 'string', format: 'uuid' } },
  'POST /api/v1/departments/{departmentId}/restore': {
    departmentId: { type: 'string', format: 'uuid' },
  },
  'POST /api/v1/departments/{departmentId}/delete': {
    departmentId: { type: 'string', format: 'uuid' },
  },
  'POST /api/v1/teams/{teamId}/restore': { teamId: { type: 'string', format: 'uuid' } },
  'POST /api/v1/teams/{teamId}/delete': { teamId: { type: 'string', format: 'uuid' } },
  'POST /api/v1/positions/{positionId}/archive': { positionId: { type: 'string', format: 'uuid' } },
  'POST /api/v1/positions/{positionId}/restore': { positionId: { type: 'string', format: 'uuid' } },
  'POST /api/v1/positions/{positionId}/delete': { positionId: { type: 'string', format: 'uuid' } },
  'POST /api/v1/employees/{employeeId}/archive': { employeeId: { type: 'string', format: 'uuid' } },
  'POST /api/v1/employees/{employeeId}/restore': { employeeId: { type: 'string', format: 'uuid' } },
  'POST /api/v1/employees/{employeeId}/delete': { employeeId: { type: 'string', format: 'uuid' } },
  'POST /api/v1/employees/bulk': {},
  'POST /api/v1/employees/import/preview': {},
  'POST /api/v1/employees/import': {},
} satisfies Record<string, Record<string, FormSchema>>;
